const getOS = _theme.getOS();
function tweakBVLayout() {
  $('.grid-item[aria-hidden="true"]').each(function () {
    const productDetails = $(this).find('[data-bv-show="rating_summary"] button').eq(0);
    const gridWishList = $(this).find('.smartwishlist').eq(0);
    if (productDetails.length && gridWishList.length) {
      productDetails.attr('tabindex', '-1');
      gridWishList.attr('tabindex', '-1');
    }
  });
}
_theme.initSlideShow = function () {
  if ($('[data-init-slideshow]').length) {
    $('[data-init-slideshow]').slick({
      infinite: true,
      prevArrow:
        "<button type='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      nextArrow:
        "<button type='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }
  //$(window).width()>767 &&
  if ($('.brand-slider-items').length) {
    $('.brand-slider-items').slick({
      dots: false,
      arrows: true,
      // prevArrow: "<button type='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      // nextArrow: "<button type='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''></button>",
      autoplay: true,
      infinite: true,
      autoplaySpeed: 1000,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 3,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 6,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: 'unslick',
        },
      ],
    });
  }

  // if ($(window).width() > 767) {
  //   $('img.slide-mobile').remove()
  // } else {
  //   $('img.slide-pc').remove()
  // }
};

_theme.initHorizontalScroll = function () {
  // $('[data-toggle]').click(function (evt) {
  //   evt.preventDefault()
  //   // $(this).closest('.panel').find('.panel-collapse').stop().slideToggle();
  //   $(this).closest('.panel').find('.panel-title').toggleClass('rotateArrow');
  //   // console.log($(this) , "this instence");
  //   $(this).attr('aria-expanded') == 'false' ? $(this).attr('aria-expanded','true') : $(this).closest('.panel').find('.panel-title a').attr('aria-expanded','false');
  // });
  $('.klarna-faq-drop .default-expanded').click(function (evt) {
    evt.preventDefault();
    $(this).closest('.content.faq').find('.panel-collapse').stop().slideToggle();
    const attrStatus = $(this).attr('aria-expanded');
    if (attrStatus === 'true') {
      $(this).attr('aria-expanded', 'false');
    } else {
      $(this).attr('aria-expanded', 'true');
    }
  });
  $('.klarna-faq-drop .collapsed[data-toggle]').click(function (evt) {
    evt.preventDefault();

    $(this).closest('.content.faq').find('.panel-collapse').stop().slideToggle();
    const attrStatus = $(this).attr('aria-expanded');
    if (attrStatus === 'false') {
      $(this).attr('aria-expanded', 'true');
    } else {
      $(this).attr('aria-expanded', 'false');
    }
  });
  $('enquiryform-div [data-toggle]').click(function (evt) {
    evt.preventDefault();
    $(this).closest('.contact.faq').find('.panel-collapse').stop().slideToggle();
  });
};

_theme.initPriceOff = function () {
  $('.custom-discount').each(function () {
    const t = Number($(this).attr('data-old-price').replace('$', '')),
      e = Number($(this).attr('data-current-price').replace('$', ''));
    if (e > t) $(this).text('');
    else {
      const a = t - e;
      $(this).html(
        "<strong class='pink_color'>Save up to $" + Math.ceil(a).toFixed(0) + '</strong>'
      );
    }
    $(this).closest('.price-box').show();
  });
};

_theme.setMinicartHeight = function () {
  if (getOS === 'ios') {
    $('.cart-bottom-footer').addClass('heightAdjust');
  }
};

_theme.initHeaderEvetns = function () {
  const mob_dropdn = $('.site-footer .dropdow-mb');
  window.innerWidth < 1025
    ? mob_dropdn.length &&
      mob_dropdn.off('click.slideToggle').on('click.slideToggle', function () {
        $(this).closest('.col-footer').siblings('.col-footer').find('.dropcollapse').slideUp();
        $(this).next().slideToggle(),
          $(this).toggleClass('open'),
          'false' == $(this).attr('aria-expanded')
            ? $(this).attr('aria-expanded', 'true')
            : $(this).attr('aria-expanded', 'false');
      })
    : mob_dropdn.next().css({ display: '' });

  $('.footer-pane-item.shopMenu').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    _theme.showMobileMenu();
  });

  $(document).on('click', '.wrapper-overlay,.mb-area-mob .close-mob-trig', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const isCloseButton = e.currentTarget && e.currentTarget.classList.contains('close-mob-trig');
    _theme.closeMobileMenu(true, isCloseButton);
    if ($('.transcript-modal')) {
      $('.transcript-modal').removeClass('active');
    }
    if($('html').hasClass('logPop')){
      $('html').removeClass('logPop');
    }
  });

  function handleSubmenuTrigger(evt) {
    evt.preventDefault();
    if ($(window).width() > 1025) {
      handleDesktopMegaMenu.call(this, evt);
    } else {
      handleMobileMegaMenu.call(this, evt);
    }
  }

  function handleDesktopMegaMenu(evt) {
    const $self = $(this);
    const $parent = $(this).closest('li.menu-lv-1');
    $parent.toggleClass('active').siblings('li').removeClass('active');
    const attr = $(this).attr('aria-expanded') || false;
    const $submenu = $self.next('.sub-menu-mobile');
    $(this).attr('aria-expanded', !JSON.parse(attr));
    $('.sub-inner-button').attr({ 'aria-hidden': true, tabindex: -1 });

    setTimeout(() => {
      $submenu.off('keydown').on('keydown', function (evt) {
        if (evt.key === 'Escape') {
          $parent.removeClass('active');
          $self.focus();
          $self.attr('aria-expanded', false);
        }
      });

      $submenu.off('focusout').on('focusout', function (evt) {
        if (evt.relatedTarget && !$submenu[0].contains(evt.relatedTarget)) {
          $parent.removeClass('active');
          $self.attr('aria-expanded', false);
        }
      });
    }, 250);
  }

  function handleMobileMegaMenu(evt) {
    const $self = $(this);
    let expand = $(this).attr('aria-expanded') || false;
    expand = JSON.parse(expand);
    $(this).attr('aria-expanded', !expand);
    let $menu = $(this).next('.sub-menu-mobile');
    if ($menu.length === 0) $menu = $(this).parent().find('.sub-menu-mobile').first();
    const isOpen = $menu.hasClass('sub-menu-open');
    if (isOpen) {
      $menu.removeClass('sub-menu-open');
      $('.mb-area-mob').css({ 'overflow-y': 'auto' });
      $menu.attr('aria-hidden', 'true');
    } else {
      setTimeout(() => {
        $menu.addClass('sub-menu-open').css({ overflow: '' });
      }, 500);
      $('.mb-area-mob').css({ overflow: 'hidden' });
      $menu.attr('aria-hidden', 'false');
    }

    $(this).animate({ scrollTop: 0 }, 0);
    $(this).css({ overflow: 'hidden' });

    setTimeout(function () {
      if (_theme.isIpad) {
        if ($menu.hasClass('sub-menu-open')) {
          $self.closest('.menu-lv-1').siblings().attr('aria-hidden', 'true');
          $self.closest('.sub-menu-mobile').find('.menu-col-banner').attr('aria-hidden', 'true');
          $self.closest('[data-griditem]').siblings().attr('aria-hidden', 'true');
          $('.sub-inner-button').attr({ 'aria-hidden': false, tabindex: 0 });
        }
      }

      _theme.focusTrap($menu, function () {
        $menu.removeClass('sub-menu-open');
        $self.attr('aria-expanded', false);
        $self.focus();
      });
    }, 650);
  }
  $('.site-nav [data-toggle-menu-mb]').off('click keydown').on('click', handleSubmenuTrigger);
  $(document)
    .off('click', '.sub-menu-mobile .cm-mega-menu-alpha-cd')
    .on('click', '.sub-menu-mobile .cm-mega-menu-alpha-cd', handleHeaderBrandLetterClick);
  $(document)
    .off('keydown', '.sub-menu-mobile .cm-mega-menu-alpha-cd')
    .on('keydown', '.sub-menu-mobile .cm-mega-menu-alpha-cd', handleHeaderBrandLetterClick);
  $(document)
    .off('click', '.cm-mega-menu-filter-title strong')
    .on('click', '.cm-mega-menu-filter-title', handleHeaderAllBrands);
  $(document)
    .off('keydown', '.cm-mega-menu-filter-title strong')
    .on('keydown', '.cm-mega-menu-filter-title', handleHeaderAllBrands);

  function handleHeaderAllBrands(evt) {
    let run = false;
    if (evt.type && evt.type === 'click') {
      if (evt.pointerId !== -1) run = true;
      if (evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
    }
    if ((evt.keyCode && evt.keyCode === 13) || evt.keyCode === 32) run = true;
    if (!run) return;
    $('.cm-mega-menu-alpha-cd').removeClass('active');
    $('.cm-mega-menu-filter-content li').removeClass('show-filter-li');
    $('.cm-mega-menu-filter-content').removeClass('show-area');
    $('.cm-mega-menu-tp-1-menu').addClass('show-area').find('a').first().focus();
  }

  function handleHeaderBrandLetterClick(evt) {
    let run = false;
    if (evt.type && evt.type === 'click') {
      if (evt.pointerId !== -1) run = true;
      if (evt.originalEvent && evt.originalEvent.pointerId !== -1) run = true;
    }
    if ((evt.keyCode && evt.keyCode === 13) || evt.keyCode === 32) run = true;
    if (!run) return;
    $(this)
      .addClass('active')
      .attr('aria-selected', true)
      .siblings()
      .removeClass('active')
      .attr('aria-selected', false);
    $(this).attr('aria-pressed', 'true').siblings().attr('aria-pressed', 'false');
    let letter = $(this).data('letter');
    if (!letter) return;
    letter = letter.toLowerCase().trim();
    $('span.go-back-ttl-a-z-t').text(letter);
    let list = '';
    _theme.vendors.map(function (brand) {
      const first_letter = brand.substr(0, 1).toLowerCase().trim();
      if (letter === first_letter) {
        list +=
          '<li class="show-filter-li"><a aria-label="' +
          brand +
          '" href="/collections/' +
          _theme.Helpers.handleize(brand) +
          '">' +
          brand +
          '</a></li>';
      }
    });
    $('[data-header-brands-list]').empty().html(list);
    $('.cm-mega-menu-tp-1-menu').removeClass('show-area');
    $('.cm-mega-menu-filter-content').addClass('show-area');
    $('.cm-mega-menu-filter-content [data-header-brands-list] li:first-child a').focus();
  }

  if ($(window).width() > 1199) {
    $('.site-nav .no-mega-menu .sub-menu-mobile').remove();
  }

  $('.site-nav-dropdown a span').each(function () {
    const txt = $(this).text();
    const clas = txt.toLowerCase().replaceAll(' ', '_');
    $(this).parent('a').addClass(clas);
  });

  if ($(window).width() > 1199) {
    $('.site-nav-desktop > li.menu-lv-1.mega-menu > a.menu__moblie')
      .off('keydown click')
      .on('keydown', handleMegaMenu);
    $('.site-nav-desktop > li.menu-lv-1.mega-menu > .sub-menu-mobile')
      .off('keyup')
      .on('keyup', handleMegaMenuEspKey);

    function handleMegaMenu(evt) {
      if (evt.which && evt.which === 9) return;
      evt.preventDefault();
      if (evt.type === 'click' && evt.originalEvent.pointerId !== -1 && false) {
        if (this.href && this.href !== '#' && this.href.indexOf('javascript') === -1)
          window.location.href = this.href;
      } else {
        const $parent = $(this).closest('li.menu-lv-1');
        let show = false; //evt.keyCode == 13 &&
        if (evt.type === 'click' && evt.originalEvent.pointerId === -1) show = true;
        if (evt.which && (evt.which == 13 || evt.which == 32)) show = true;

        if (show) {
          $parent.toggleClass('active').siblings('li').removeClass('active');
        } else {
          const activeParent = $(document.activeElement).closest('li.menu-lv-1.active')[0];
          if (!activeParent) {
            $(this).closest('.site-nav').find('li.menu-lv-1.active').removeClass('active');
          }
        }
      }
    }

    function handleMegaMenuEspKey(evt) {
      if (evt.keyCode && evt.keyCode !== 27) return;
      const $parent = $(this).closest('li.menu-lv-1');
      $parent.removeClass('active');
      $parent.find('a.menu__moblie').attr('aria-expanded', false).focus();
    }
  }
};

_theme.pushBackButton = (function () {
  function init() {
    const pushBackButton = $('.backButtonMain');
    pushBackButton.off('click').on('click', function (e) {
      e.preventDefault();
      _theme.Helpers.goToPreviousPage();
    });
  }
  return { init: init };
})();

_theme.initNavigationEvents = function () {
  setTimeout(function () {
    $('.cm-mega-menu-filter-alpha .cm-mega-menu-alpha-cd.alpha-cd-a').click();
  }, 100);
  $(
    'body .mb-area-mob .site-nav .menu-mb-title .close-mob-trig, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title .close-mob-trig'
  ).remove();
  $(
    'body .mb-area-mob .site-nav .menu-mb-title, body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .menu-mb-title'
  ).append(
    '<button aria-label="close" class="close-mob-trig"><img src="//cdn.shopify.com/s/files/1/1708/6649/files/Closemobi.png?v=17908549624479407508" alt=""></button>'
  );

  $(
    'body .mb-area-mob .site-nav .menu-mb-title .icon-dropdown + span,body .mb-area-mob .site-nav .menu-mb-title > button.back-btn'
  ).click(function (e) {
    e.stopPropagation();
    const $parentMenu = $(this).closest('.sub-menu-mobile.sub-menu-open');
    const $triggerButton = $parentMenu.prev();
    const $innerOpenMenu = $parentMenu.find('.sub-menu-mobile.sub-menu-open');
    const $isShopByBrand = $(this).closest('.cm-mega-menu-tp-1');

    if ($isShopByBrand.length) {
      $isShopByBrand.removeClass('a-z-active');
      $isShopByBrand
        .find('.cm-mega-menu-tp-1-col.col-left .cm-mega-menu-filter-menu')
        .removeClass('sub-menu-open');
      $isShopByBrand.find('.cm-mega-menu-filter-content').addClass('show-area');
      $triggerButton.attr('aria-expanded', 'false');
    } else {
      if ($innerOpenMenu.length) {
        $innerOpenMenu.removeClass('sub-menu-open');
        $triggerButton.attr('aria-expanded', 'false');
      } else {
        $parentMenu.removeClass('sub-menu-open');
        $triggerButton.closest('.menu-lv-1').siblings().removeAttr('aria-hidden');
        $triggerButton
          .closest('.sub-menu-mobile')
          .find('.menu-col-banner')
          .removeAttr('aria-hidden');
        $triggerButton.closest('[data-griditem]').siblings().removeAttr('aria-hidden');
        setTimeout(() => {
          $parentMenu.closest('.menu-lv-2').siblings().removeAttr('aria-hidden');
        }, 650);
        $triggerButton.attr('aria-expanded', 'false');
      }
    }
  });

  $('span.go-back-ttl').click(function (e) {
    $(this).parent().parent('.cm-mega-menu-dl-back').removeClass('sub-menu-open');
    e.stopPropagation();
  });
  $('span.a-z-back-btn').click(function (e) {
    $(this).parent().parent('.cm-mega-menu-filter-menu').removeClass('sub-menu-open');
    e.stopPropagation();
  });

  // if(_theme.isIpadAndUp){
  //   $('span.go-back-ttl-a-z-t').click(function (e) {
  //     $(this).parent().parent('.cm-mega-menu-filter-content').removeClass('show-area');
  //     e.stopPropagation();
  //   });
  // }

  $('body .mb-area-mob .site-nav .mega-menu .menu-lv-2 .icon-dropdown').click(function (e) {
    e.preventDefault();
    const $self = $(this);
    $self.parent().next().toggleClass('sub-menu-open');
    $self.closest('.menu-lv-1').siblings().attr('aria-hidden', 'true');
    $self.closest('.sub-menu-mobile').find('.menu-col-banner').attr('aria-hidden', 'true');
    $self.closest('[data-griditem]').siblings().attr('aria-hidden', 'true');
    $('.sub-inner-button').attr({ 'aria-hidden': false, tabindex: 0 });
    $self.closest('.menu-lv-2').siblings().attr('aria-hidden', 'true');
    _theme.focusTrap($self.parent().next());
  });
  $('.site-nav .mega-menu .go-fronf').click(function (e) {
    e.preventDefault();
    const $mainParent = $(this).closest('.cm-mega-menu-tp-1');
    const $parent = $(this).closest('.cm-mega-menu-tp-1-col');
    $parent.find('.cm-mega-menu-filter-menu').addClass('sub-menu-open');
    $mainParent.addClass('a-z-active');
  });
};

_theme.removeElements = function () {
  if (window.innerWidth < 1200) {
    const headerFindStore = document.querySelector(
      '.header-top .top-message .find-a-store.header-top-bar'
    );
    headerFindStore && headerFindStore.remove();
    $('.header-top .top-message .find-a-store.header-top-bar').remove();
    $('.home-blog-posts').remove();
    $('.cm-footer-content').remove();
  }
  if (window.innerWidth < 768) {
    // $("h2.foot-title.dropdow-mb").attr("role", "button").removeAttr('aria-level');
    $('h2.foot-title.dropdow-mb').removeAttr('aria-level');
    $('h2.foot-title.dropdow-mb').attr('tabindex', '0');
    $('h2.foot-title.dropdow-mb').each(function () {
      const t = $(this).text().trim();
      $(this).attr('aria-label', t),
        $(this).attr('aria-expanded', 'false'),
        $(this).on('keydown', function (t) {
          13 == t.which && $(this).trigger('click');
        });
    });
  }
};

_theme.initChatWidget = function () {
  try {
    if (!window.LiveChatWidget) return;

    LiveChatWidget.call('hide');

    function onVisibilityChanged(data) {
      switch (data.visibility) {
        case 'maximized':
          break;
        case 'minimized':
          LiveChatWidget.call('hide');
          break;
        case 'hidden':
          break;
      }
    }

    LiveChatWidget.on('visibility_changed', onVisibilityChanged);

    $(document).on('click', '.btn-chat', function () {
      LiveChatWidget.call('maximize');
    });

    $(document).on('click', '.footer-pane-item.support-chat', function () {
      LiveChatWidget.call('maximize');
    });

    const chats = document.querySelectorAll('[data-chat-toggle]');
    chats.forEach(function (chat) {
      chat.addEventListener('click', function (evt) {
        evt.preventDefault();
        window.LiveChatWidget.call('maximize');
      });
    });

    function onAvailabilityChanged(data) {
      if (data.availability === 'online') {
        const elementSup = document.querySelector(
          '.footer-pane-grid .footer-pane-item.support-chat .small-des'
        );
        if (elementSup) {
          elementSup.textContent = 'Chat Now';
        }
      } else {
        const elementChat = document.querySelector(
          '.footer-pane-grid .footer-pane-item.support-chat .small-des'
        );
        if (elementChat) {
          elementChat.textContent = 'Support';
        }
      }
      $('.footer-pane-item.support-chat .icon,.footer-pane-item.support-chat .content').removeClass(
        'hide'
      );
      $('.footer-pane-item.support-chat .footer-pane-loader').addClass('hide');
    }

    LiveChatWidget.on('availability_changed', onAvailabilityChanged);
  } catch (error) {
    console.error('Error in _theme.initChatWidget:', error);
  }
};

_theme.initAccessibility = function () {
  const elm = document.querySelector('.footer-pane-item.accessbility');
  if (elm) {
    elm.addEventListener('click', function () {
      document.querySelector('.acsb-trigger.acsb-trigger-size-medium').click();
    });
  }
  function checkadbsExist() {
    if ($('.acsb-actions-active').length) {
      $('.footer-pane-item.accessbility .active_accessbility').removeClass('hide');
      $('.footer-pane-item.accessbility').addClass('blue');
      $('.footer-pane-item.accessbility ._accessbility').addClass('hide');
    } else {
      $('.footer-pane-item.accessbility').removeClass('blue');
      $('.footer-pane-item.accessbility .active_accessbility').addClass('hide');
      $('.footer-pane-item.accessbility ._accessbility').removeClass('hide');
    }
  }
  $('.footer-pane-item.accessbility .icon,.footer-pane-item.accessbility .content').removeClass(
    'hide'
  );
  $('.footer-pane-item.accessbility .footer-pane-loader').addClass('hide');
  $(window).on('load', function () {
    setTimeout(function () {
      checkadbsExist();
    }, 700);
  });
  $(document).on('click', '[data-acsb-option="close"]', function () {
    checkadbsExist();
  });
};

_theme.loadAppScript = function () {
  if (!_theme.appsScripts || _theme.appsScripts.length === 0) return;
  const initLiveChat =
    _theme.settings.livechat_enable && _theme.settings.livechat_type === 'default';
  let isRewardScriptCritical = false;
  const urlHash = window.location.hash;
  isRewardScriptCritical =
    window.location.pathname.indexOf('/pages/rewards-program') > -1 ? true : false;
  if (!isRewardScriptCritical && urlHash && urlHash.indexOf('#smile') > -1) {
    isRewardScriptCritical = true;
  }

  const isHomePage = document.querySelector('body.template-index');
  const criticalScripts = _theme.appsScripts.filter(function (script_src) {
    let status = false;
    if (script_src.indexOf('bazaarvoice') > -1) status = true;
    if (script_src.indexOf('searchanise') > -1) status = true;
    if (script_src.indexOf('searchserverapi') > -1) status = true;
    if (script_src.indexOf('klarna') > -1) status = true;
    if (script_src.indexOf('smartwishlist') > -1) status = true;
    if (script_src.indexOf('services.nofraud.com') > -1) status = true;
    if (script_src.indexOf('easyredirects') > -1) status = true;
    if (script_src.indexOf('signifyd') > -1) status = true;

    if (script_src.indexOf('d10lpsik1i8c69.cloudfront.net') > -1) status = false; // loading on <head> "head-app-script.liquid" file

    if (isRewardScriptCritical) if (script_src.indexOf('smile.io') > -1) status = true;

    return status;
  });

  const nonCriticalScripts = _theme.appsScripts.filter(function (script_src) {
    let status = true;
    if (script_src.indexOf('bazaarvoice') > -1) status = false;
    if (script_src.indexOf('searchanise') > -1) status = false;
    if (script_src.indexOf('searchserverapi') > -1) status = false;
    if (script_src.indexOf('klarna') > -1) status = false;
    if (script_src.indexOf('smartwishlist') > -1) status = false;
    if (script_src.indexOf('services.nofraud.com') > -1) status = false;
    if (script_src.indexOf('easyredirects') > -1) status = false;
    if (script_src.indexOf('signifyd') > -1) status = false;

    if (script_src.indexOf('d10lpsik1i8c69.cloudfront.net') > -1) status = false; // loading on <head> "head-app-script.liquid" file

    if (isRewardScriptCritical) if (script_src.indexOf('smile.io') > -1) status = false;

    return status;
  });

  criticalScripts.map(function (s) {
    appendScript(s);
  });

  const biJsHost = 'https:' == document.location.protocol ? 'https://' : 'http://';
  !(function (a, c, d, f, g) {
    let b,
      e = a.getElementsByTagName(c)[0];
    a.getElementById(d) ||
      (((b = a.createElement(c)).id = d),
      (b.src = biJsHost + 'cdn.listrakbi.com/scripts/script.js?m=' + f + '&v=1'),
      e.parentNode.insertBefore(b, e));
  })(document, 'script', 'ltkSDK', 'hQcA0lXRfUMl', '1');
  window.ju_num = '97C574A7-F784-4540-9BD2-350105729FB5';
  window.asset_host = '//cdn.jst.ai/';
  (function (i, s, o, g, r, a, m) {
    i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      };
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', asset_host + 'vck.js', 'juapp');

  let script_loaded = false;
  if (initLiveChat) {
    // Load LiveChat script immediately for all devices
    ; (function (n, t, c) { function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n) } var e = { _q: [], _h: null, _v: "2.0", on: function () { i(["on", c.call(arguments)]) }, once: function () { i(["once", c.call(arguments)]) }, off: function () { i(["off", c.call(arguments)]) }, get: function () { if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load."); return i(["get", c.call(arguments)]) }, call: function () { i(["call", c.call(arguments)]) }, init: function () { var n = t.createElement("script"); n.async = !0, n.type = "text/javascript", n.src = "https://cdn.livechatinc.com/tracking.js", t.head.appendChild(n) } }; !n.__lc.asyncInit && e.init(), n.LiveChatWidget = n.LiveChatWidget || e }(window, document, [].slice))
    
    // Initialize chat widget once LiveChatWidget is available
    function initChatWhenReady() {
      if (window.LiveChatWidget && window.LiveChatWidget._h) {
        _theme.initChatWidget();
      } else {
        setTimeout(initChatWhenReady, 100);
      }
    }
    initChatWhenReady();
  }
  document.addEventListener('scroll', loadScriptOnScroll);
  function loadScriptOnScroll() {
    if (window.pageYOffset > 10 && !script_loaded) {
      script_loaded = true;
      nonCriticalScripts.map(function (s) {
        appendScript(s);
      });
      document.removeEventListener('scroll', loadScriptOnScroll);
    }
  }
  function appendScript(script_url) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true; // s.defer = 'defer';
    s.src = script_url;
    const x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }
  
  delete _theme.appsScripts;
};

_theme.initGTM = function () {
  window.dataLayer = window.dataLayer || [];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.onload = () => {
    dataLayer.push({ event: 'gtm.js', 'gtm.start': new Date().getTime(), 'gtm.uniqueEventId': 0 });
  }; // this part ensures PageViews is always tracked
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-N5537BV';
  document.head.appendChild(script);
};

_theme.loadSection = function () {
  document.querySelector('.fcp').remove();

  const sections = document.querySelectorAll('.section--async');
  if (sections.length === 0) return;
  const observer = new IntersectionObserver(
    function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const section = entry.target;
          try {
            const section_json = JSON.parse(
              section.querySelector('[data-section-script]').textContent
            );
            section.innerHTML = section_json.html;
            if (section_json.type === 'home_featured_products') {
              loadFeaturedProductsEvents(section);
              _theme.initSmartWishlist();
              handleWishlistChange && handleWishlistChange();
            }
            setTimeout(function () {
              tweakBVLayout();
            }, 3000);
          } catch (err) {
            console.log('Error', err);
          }
          observer.unobserve(section);
        }
      });
    },
    {
      root: null,
      threshold: 0.05,
    }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });
  function loadFeaturedProductsEvents(section) {
    _theme.initSlickSlider(
      $(section).find('.home-products-slider'),
      {
        infinite: false,
        arrows: true,
        dots: false,
        // prevArrow: "<button aria-label='Previous' class=\"slick-arrow slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
        // nextArrow: "<button aria-label='Next' class=\"slick-arrow slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
        prevArrow:
          '<button class="slick-prev slick-prev slider-slick-prev" aria-label="Previous" type="button" tabindex="-1"><i class="arrow1 left1"></i><span class="sr-only">Previous</span></button>',
        nextArrow:
          '<button class="slick-next slick-next slider-slick-next" aria-label="Next" type="button" tabindex="-1"><i class="arrow1 right1"></i><span class="sr-only">Next</span></button>',
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      },
      function (slick) {
        $(this).on(
          'init afterChange beforeChange',
          function (event, slick, currentSlide, nextSlide) {
            _theme.slickCallback(slick);
          }
        );
        setTimeout(() => {
          $(this).on(
            'init afterChange beforeChange',
            function (event, slick, currentSlide, nextSlide) {
              _theme.slickCallback(slick);
            }
          );
        }, 2000);
      }
    );
  }
};
_theme.initSlickSlider = function (selector, settings, initCallBack, afterChangeCallBack) {
  if (!selector || !settings) return;
  let $productGrid = selector;
  if (typeof selector === 'string') {
    $productGrid = $(selector);
  }
  if (typeof selector === 'object' && !$productGrid.hasOwnProperty('length')) {
    $productGrid = $(selector);
  }

  if ($productGrid.length === 0) return;

  if ($productGrid.hasClass('slick-initialized')) {
    $productGrid.slick('unslick');
  }
  $productGrid.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
    }, 1000);
  });
  $productGrid.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
    slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
    }, 2000);
    if (afterChangeCallBack && typeof afterChangeCallBack === 'function')
      afterChangeCallBack(slick);
  });
  $productGrid.on('init', function (event, slick, currentSlide, nextSlide) {
    slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
    slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide').removeAttr('tabindex');
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
    }, 1000);

    const check_smartwishlist = setInterval(function () {
      const wishlistEle = slick.$slider.find('.slick-slide[aria-hidden="true"] .smartwishlist');
      if (wishlistEle.length) {
        wishlistEle.attr('tabindex', -1);
        clearInterval(check_smartwishlist);
      }
    }, 1000);

    const check_bv_container = setInterval(function () {
      const bvEle = slick.$slider.find('.slick-slide[aria-hidden="true"] .bv_main_container');
      if (bvEle.length) {
        bvEle.attr('tabindex', -1);
        clearInterval(check_bv_container);
      }
    }, 1000);

    if (initCallBack && typeof initCallBack === 'function') initCallBack(slick);
  });

  $productGrid.slick(settings);
};

_theme.initLazyloadData = function () {
  const sections = document.querySelectorAll('[data-async]');
  if (sections.length === 0) {
    _theme.initNavigationEvents();
    return;
  }

  sections.forEach(function (section) {
    try {
      const section_json = JSON.parse(section.querySelector('[data-section-script]').textContent);
      section.innerHTML = '';
      section.innerHTML = section_json.html;
    } catch (err) {}
  });

  _theme.initNavigationEvents();
};

_theme.toggleAjaxModal = function (show, msg) {
  if (show && msg) {
    $('.ajax-error-modal .ajax-error-message').text(msg);
    $('.ajax-error-modal').fadeIn();
    setTimeout(function () {
      $('.ajax-error-modal').fadeOut();
    }, 2000);
  } else {
    $('.ajax-error-modal').fadeOut();
  }
};

_theme.footerPaneEvents = function () {
  if (window.innerWidth < 768) {
    const closeSiblinGFooterPopups = (e) => {
      const closeAccountPop = document.querySelector(
        '.form-popup.toggle-slides [data-close-popup]'
      );
      const menuCloseButton = document.querySelector('.mb-area-mob .close-mob-trig');
      if (closeAccountPop) {
        closeAccountPop.click();
      }
      if (menuCloseButton) {
        menuCloseButton.click();
      }
    };

    // const chatFooterBtn = document.querySelector('.footer-pane-item.support-chat')
    const rewardFooterBtn = document.querySelector('.footer-pane-item.rewards');
    rewardFooterBtn.addEventListener('click', closeSiblinGFooterPopups);
    // chatFooterBtn.addEventListener('click',closeSiblinGFooterPopups)
  }
};
_theme.initMobileEvents = function (unload) {
  const mobileMenu = document.querySelector('.mb-area-mob');
  if (!mobileMenu) return;
  if (unload) {
    mobileMenu.removeEventListener('focusout', menuHandleFocusOut);
  } else {
    mobileMenu.addEventListener('focusout', menuHandleFocusOut);
  }

  function menuHandleFocusOut() {
    if (!this.contains(document.activeElement)) {
      $('.mb-area-mob .close-mob-trig').click();
    }
  }
};

_theme.updateDOMOnResize = function () {
  window.onresize = debounce(function () {
    if (window.innerWidth > 767) {
      if (window.LiveChatWidget) LiveChatWidget.call('minimize');
    } else {
      if (window.LiveChatWidget) LiveChatWidget.call('hide');
    }
  });
};

_theme.Wishlist = (function () {
  const WISHLIST_KEY = 'wishListsArr';
  let wishlist_arr = null;

  function init() {
    $('[data-icon-wishlist]')
      .off('click')
      .on('click touchend', function (evt) {
        evt.preventDefault();
        if (!_theme.settings.customer) {
          $('.cm-log-in-form').css('display', 'block').addClass('show');
        }
        const $self = $(this);
        wishlist_arr = getWishlistHandles() || [];
        const handle = $self.data('product-handle');
        const item_index = wishlist_arr.indexOf(handle);
        const isAdded = $self.hasClass('whislist-added') ? true : false;
        const p_id = $self.data('id');
        if (item_index !== -1 && isAdded) removeProductFromWishlist(handle, p_id, $self);
        else addProductToWishlist(handle, $self);
      });

    if ($('body.template-page [data-wishlist-container]').length) {
      initWishlistProductGrid();
    }
    updateWishlistStatus();
    handleWishlistChange && handleWishlistChange();
  }

  function updateWishlistStatus(title) {
    wishlist_arr = getWishlistHandles();
    if (!wishlist_arr) return;
    wishlist_arr.map(function (handle) {
      const a = $('[data-product-handle="' + handle + '"]');
      a.addClass('whislist-added');
      let prefix = title ? title : a.data('title') ? a.data('title') : '';
      prefix = prefix ? prefix : a.closest('.product-item').find('.product-title span').text();
      prefix = prefix ? prefix : '';
      $('body').hasClass('template-product')
        ? a.attr('aria-label', prefix + ' ' + window.inventory_text.remove_wishlist)
        : a.attr(
            'aria-label',
            'Remove to Wishlist of ' +
              a.closest('.product-item').find('.product-title span').text() +
              ' '
          );
      a.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
    });
  }

  function initWishlistProductGrid() {
    wishlist_arr = getWishlistHandles();
    if (!wishlist_arr) return;
    _theme.toggleLoading(1);
    const placeholder_index = wishlist_arr.indexOf('[[Product_Handle]]');
    if (placeholder_index > -1) wishlist_arr.splice(placeholder_index, 1);
    const temp_arr = wishlist_arr.concat([]);
    const products = [];
    fetchData();
    function fetchData() {
      if (temp_arr.length) {
        const handle = temp_arr.shift();
        fetch('/products/' + handle + '.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (res) {
            products.push(res);
            fetchData();
          })
          .catch(function (err) {
            console.log(err);
          });
      } else {
        if (products.length) {
          $('.wishlist-page').removeClass('wishlist--empty');
          products.map(function (p) {
            buildWishlistProductGrid(p);
          });
          initWishlistProductGridEvents();
        } else {
          $('.wishlist-page').addClass('wishlist--empty');
        }
        _theme.toggleLoading();
      }
    }
  }

  function initWishlistProductGridEvents() {
    handleWishlistChange && handleWishlistChange();
    $(document)
      .off('click', '[data-btn-addtocart]')
      .on('click', '[data-btn-addtocart]', function (evt) {
        evt.preventDefault();
        const vid = $(this).closest('form').find('[name="id"]').val();
        if (!vid) return;
        $(this).closest('[data-wishlist-container]').addClass('processing');
        _theme.toggleLoading(1);
        Shopify.addItem(vid, 1, function () {
          Shopify.getCart(function (cart) {
            _theme.MiniCart.lineItemChangeCallBack(cart, function () {
              _theme.toggleLoading();
              $('[data-wishlist-container]').removeClass('processing');
              _theme.toggleSideCart(1, null, true);
            });
          });
        });
      });
  }

  function buildWishlistProductGrid(t) {
    if (!t) return;
    const $wishlistContainer = $('[data-wishlist-container]');
    let e = '',
      i = Shopify.formatMoney(t.price_min, window.money_format);
    (e += '<div class="grid-item" data-wishlist-added="wishlist-' + t.id + '">'),
      (e += '<div class="inner product-item" data-product-id="product-' + t.handle + '">'),
      (e += '<div class="column col-img"><div class="product-image">'),
      (e +=
        '<div href="' +
        t.url +
        '" class="product-grid-image" data-collections-related="/collections/all?view=related">'),
      (e += '<img src="' + t.featured_image + '" alt="' + t.featured_image.alt + '">'),
      (e += '</div></div></div>'),
      (e += '<div class="column col-prod">'),
      (e += '<div class="product-vendor">'),
      (e +=
        '<a href="/collections/vendors?q=' +
        t.vendor +
        '" title="' +
        t.vendor +
        '">' +
        t.vendor +
        '</a></div>'),
      (e +=
        '<a class="product-title" href="' +
        t.url +
        '" title="' +
        t.title +
        '">' +
        t.title +
        '</a></div>'),
      (e += '<div class="column col-price text-center"><div class="p-price">' + i + '</div></div>'),
      (e +=
        '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="' +
        t.handle +
        '" data-icon-wishlist data-id="' +
        t.id +
        '"><svg class="closemnu" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 357 357" xml:space="preserve"><g><g><polygon points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon></g></g></svg></a></div>'),
      (e += '<div class="column col-options text-center">'),
      (e +=
        '<form action="/cart/add" method="post" class="variants" id="-' +
        t.id +
        '" data-id="product-actions-' +
        t.id +
        '" enctype="multipart/form-data">'),
      t.available
        ? (1 == t.variants.length &&
            (e +=
              '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" data-form-id="#-' +
              t.id +
              '" >' +
              window.inventory_text.add_to_cart +
              '</button><input type="hidden" name="id" value="' +
              t.variants[0].id +
              '" />'),
          t.variants.length > 1 &&
            (e +=
              '<a class="btn" title="' +
              t.title +
              '" href="' +
              t.url +
              '">' +
              window.inventory_text.select_options +
              '</a>'))
        : (e +=
            '<button data-btn-addToCart class="btn add-to-cart-btn" type="submit" disabled="disabled">' +
            window.inventory_text.unavailable +
            '</button>'),
      (e += '</form></div>'),
      (e += '</div></div>'),
      $wishlistContainer.append(e);
  }

  function addProductToWishlist(handle, $self, callback) {
    if (!handle) return;
    const title = $self.data('title');
    wishlist_arr = getWishlistHandles() || [];
    const item_index = wishlist_arr.indexOf(handle);
    if (item_index !== -1) return;
    wishlist_arr.push(handle);
    $self.addClass('whislist-added');
    $self.find('.wishlist-text').text(title + ' ' + window.inventory_text.remove_wishlist);
    $self.find('[data-aria-live]').text('Added to wishlist');
    saveWishlistProducts();
    updateWishlistStatus(title);
    if (callback && typeof callback === 'function') callback();
  }

  function removeProductFromWishlist(handle, p_id, $self, callback) {
    if (!handle) return;
    wishlist_arr = getWishlistHandles();
    if (!wishlist_arr) return;
    const title = $self.data('title');
    const item_index = wishlist_arr.indexOf(handle);
    if (item_index === -1) return;
    wishlist_arr.splice(item_index, 1);
    $self.removeClass('whislist-added');
    $self.find('.wishlist-text').text(window.inventory_text.add_wishlist);
    $self.attr('aria-label', title + ' ' + window.inventory_text.add_wishlist);
    $self.find('[data-aria-live]').text('Removed from wishlist');
    saveWishlistProducts();
    updateWishlistStatus();
    $('[data-wishlist-added="wishlist-' + p_id + '"]').length &&
      $('[data-wishlist-added="wishlist-' + p_id + '"]').remove();
    if (callback && typeof callback === 'function') callback();
  }

  function saveWishlistProducts() {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist_arr));
  }

  function getWishlistHandles() {
    wishlist_arr = JSON.parse(localStorage.getItem(WISHLIST_KEY));
    if (!wishlist_arr || wishlist_arr.length === 0) return null;

    return wishlist_arr;
  }

  return {
    init: init,
    getWishlistHandles: getWishlistHandles,
    updateWishlistStatus: updateWishlistStatus,
    initWishlistProductGrid: initWishlistProductGrid,
    addProductToWishlist: addProductToWishlist,
    removeProductFromWishlist: removeProductFromWishlist,
  };
})();

_theme.ProductGridQuickView = (function () {
  const cacheQuickview = {};
  const cache_product = {};
  let activeId = null;
  let timer;

  function init() {
    $('[data-quickview-modal]').click(function (evt) {
      const isInside = $(evt.target).closest('.halo-modal-content').length ? true : false;
      if (!isInside) {
        if ($('body').hasClass('quickViewModal')) {
          $('body').removeClass('quickViewModal');
        }
        $(this).fadeOut();
        emptyQV();
        if (activeId) {
          $('.product-item[data-product-id="' + activeId + '"] .offer-quickview-button').focus();
          activeId = null;
        }
      }
    });

    $('.ajax-quickview .close-modal').click(function () {
      $('.ajax-success-modal.halo-modal.ajax-quickview').hide();
      $('body').removeClass('quickViewModal');
      emptyQV();
      if (activeId) {
        $('.product-item[data-product-id="' + activeId + '"] .offer-quickview-button').focus();
        activeId = null;
      }
    });

    if (!_theme.isIpad) {
      $(document)
        .off('mouseenter', '.product-item .offer-quickview-button')
        .on('mouseenter', '.product-item .offer-quickview-button', function (evt) {
          timer = setTimeout(() => {
            _theme.track.trackView('Quickview');
          }, 300);
        });

      $(document)
        .off('mouseleave', '.product-item .offer-quickview-button')
        .on('mouseleave', '.product-item.offer-quickview-button', function (evt) {
          clearTimeout(timer);
        });
    }

    $(document)
      .off('click', '.product-item [data-offer-quickview-button]')
      .on('click', '.product-item [data-offer-quickview-button]', async function (evt) {
        if (evt.type !== 'click') return;

        evt.preventDefault();
        activeId = $(this).closest('.product-item').attr('data-product-id');
        const prod_url = $(this).data('url');
        const handle = $(this).data('id');
        const variantId = $(this).data('vid');
        // const c_handle = $(this).data('c_handle');
        if (!prod_url || !handle || !variantId) return;

        _theme.track.trackClick('Quickview');

        if (cacheQuickview[handle]) {
          initQuickViewSlick();
          showQV(cacheQuickview[handle].html);
        } else {
          try {
            _theme.toggleLoading(1);
            // const resp = await fetch(`/collections/${c_handle}/products/${handle}?view=quickview-new&variant=${variantId}`);
            const resp = await fetch(`${prod_url}?view=quickview-new&variant=${variantId}`);
            const text = await resp.text();
            cacheQuickview[handle] = { html: text };
            initQuickViewSlick();
            showQV(text, activeId);
            _theme.initSmartWishlist();
            _theme.toggleLoading();
          } catch (err) {
            _theme.toggleLoading();
            _theme.toggleAjaxModal(1, err.message || 'Something went wrong');
          }
        }
      });

    $(document)
      .off('click', '.product-item [data-default-quickview-button]')
      .on('click', '.product-item [data-default-quickview-button]', async function (evt) {
        if (evt.type !== 'click') return;

        evt.preventDefault();
        const $self = $(this);
        $activeElem = $self;
        const prod_url = $(this).data('url');
        const prod_id = $(this).data('id');
        const variantId = $(this).data('vid');
        if (!prod_url || !prod_id || !variantId) return;
        _theme.toggleLoading(1);

        if (cache_product[prod_id]) {
          updateSideCartQvOffer(cache_product[prod_id].html, prod_id);
        } else {
          try {
            // const resp = await fetch(`/collections/${c_handle}/${prod_url}?view=sidecart-qv&variant=${variantId}`);
            const resp = await fetch(`${prod_url}?view=sidecart-qv&variant=${variantId}`);
            const text = await resp.text();
            cache_product[prod_id] = { html: text };
            updateSideCartQvOffer(text, prod_id);
            _theme.toggleLoading();
          } catch (error) {
            console.log(error);
            _theme.toggleLoading();
            $self.removeClass('loading');
            alert('Something went wrong. Please try again later');
          }
        }
      });

    $(document)
      .off('click touchstart', '.product-item [data-mobile-quickview-button]')
      .on('click touchstart', '.product-item [data-mobile-quickview-button]', async function (evt) {
        if (evt.type === 'touchstart') {
          $(this).off('click');
        }

        evt.preventDefault();
        const $self = $(this);
        $activeElem = $self;
        const prod_url = $(this).data('url');
        const prod_id = $(this).data('id');
        const variantId = $(this).data('vid');
        if (!prod_url || !prod_id || !variantId) return;
        _theme.toggleLoading(1);

        if (cache_product[prod_id]) {
          updateMobPopoverQv(cache_product[prod_id].html, prod_id);
        } else {
          try {
            // const resp = await fetch(`/collections/${c_handle}/${prod_url}?view=sidecart-qv&variant=${variantId}`);
            const resp = await fetch(`${prod_url}?view=sidecart-qv&variant=${variantId}`);
            const text = await resp.text();
            cache_product[prod_id] = { html: text };
            updateMobPopoverQv(text, prod_id);
            _theme.toggleLoading();
          } catch (error) {
            console.log(error);
            _theme.toggleLoading();
            $self.removeClass('loading');
            alert('Something went wrong. Please try again later');
          }
        }
      });

    $(document)
      .off('click', '.search-page-qv .cm-add-bndle')
      .on('click', '.search-page-qv .cm-add-bndle', function (evt) {
        evt.preventDefault();
        _theme.focusTrap($('#dropdown-cart'), function () {
          _theme.toggleSideCart(false, null, false);
        });
        _theme.toggleLoading(1);
        const vid = $(this).parent().find('.offer-quickview-mob-button').data('vid');
        if (!vid) return;

        // Do Not Remove Code - Add Properties for GWP Discount
        const properties = {};
        const bundleVarIdElement = $(this).closest('.grid-item').find('[data-bundleVarId]');
        if (bundleVarIdElement.length > 0) {
          properties['_bundleVarId'] = bundleVarIdElement.val() || null;
        }
        // Do Not Remove Code - Add Properties for GWP Discount

        _theme.Helpers.addProductToCart(
          vid,
          1,
          properties,
          (resp) => {
            _theme.MiniCart.lineItemChangeCallBack(resp, function () {
              _theme.toggleLoading();
              _theme.toggleSideCart(1, null, true);
            });
          },
          (err) => {
            console.error(err);
          },
          1
        );
      });
  }

  function updateMobPopoverQv(res, prod_id) {
    const parser = new DOMParser();
    const html = parser.parseFromString(res, 'text/html');
    const body = html.querySelector('body');

    $('.sidecart-qv').attr('data-id', prod_id);
    $('.sidecart-qv').addClass('offer-sidecart-qv');
    $('.sidecart-qv .sidecart-qv-body').html(body.querySelector('.mob-popover-qv-body').innerHTML);
    $('.sidecart-qv .sidecart-qv-footer').html($(res).find('.sidecart-qv-cta').html());
    $('.offer-sidecart-qv .sidecart-qv-cta').html($(res).find('.sidecart-qv-cta').html(''));
    $('.offer-sidecart-qv .sidecart-qv-header').css('display', 'none');

    setTimeout(function () {
      const imgSlickContainer = $('.sidecart-qv .sidecart-qv-images .mob-popover-qv-slider');
      imgSlickContainer.on('init', function (event, slick, currentSlide, nextSlide) {
        imgSlickContainer.closest('.sidecart-qv-images').removeClass('loading');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 1000);
      });
      imgSlickContainer.slick({
        infinite: false,
        dots: true,
        arrows: false,
      });
    }, 1000);

    _theme.toggleSideCartQv(1);
    _theme.initSmartWishlist();
    _theme.toggleLoading();
    _theme.refreshKlarna();

    _theme.focusTrap(
      $('.sidecart-qv'),
      function () {
        _theme.toggleSideCartQv();
        if ($activeElem) $activeElem.focus();
        $activeElem = null;
      },
      'details'
    );
  }

  function updateSideCartQvOffer(res, prod_id) {
    const parser = new DOMParser();
    const html = parser.parseFromString(res, 'text/html');
    const body = html.querySelector('body');

    $('.sidecart-qv').attr('data-id', prod_id);
    $('.sidecart-qv').addClass('offer-sidecart-qv');
    $('.sidecart-qv .sidecart-qv-body').html(body.querySelector('.pdp-sidecart-qv-body').innerHTML);
    $('.sidecart-qv .sidecart-qv-footer').html($(res).find('.sidecart-qv-cta').html());
    $('.offer-sidecart-qv .sidecart-qv-cta').html($(res).find('.sidecart-qv-cta').html(''));

    setTimeout(function () {
      const imgSlickContainer = $('.sidecart-qv .sidecart-qv-images ul');
      imgSlickContainer.on('init', function (event, slick, currentSlide, nextSlide) {
        imgSlickContainer.closest('.sidecart-qv-images').removeClass('loading');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 1000);
      });
      imgSlickContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        arrows: true,
      });
      $('.sidecart-qv-inner .sidecart-qv-images .slick-list .slick-track').attr(
        'role',
        'presentation'
      );
    }, 1000);

    // $(".sidecart-qv .sidecart-qv-options .swatch-element.available").first().find("input").prop("checked", true);

    _theme.toggleSideCartQv(1);
    _theme.initSmartWishlist();
    _theme.toggleLoading();
    _theme.refreshKlarna();

    _theme.focusTrap(
      $('.sidecart-qv'),
      function () {
        _theme.toggleSideCartQv();
        if ($activeElem) $activeElem.focus();
        $activeElem = null;
      },
      'details'
    );
  }

  function showQV(res, activeId) {
    emptyQV();

    const parser = new DOMParser();
    const html = parser.parseFromString(res, 'text/html');
    const body = html.querySelector('body');
    $('[data-quickview-modal] .halo-modal-body').html(body.querySelector('.product'));

    const $quickviewModal = $('[data-quickview-modal]');
    const $pdpOfferLabelElem =
      $quickviewModal.find('.product-shop [id*=pdp_label_] .bogopromoTitle') ||
      $quickviewModal.find('.product-shop [id*=pdp_label_]');
    if ($pdpOfferLabelElem.length) {
      const eventText = $pdpOfferLabelElem.text()?.trim() || 'PDP Offer Label';
      _theme.track.trackView(eventText);
    }

    $('[data-quickview-modal]').attr('data-source', activeId).fadeIn(1000, 'linear');
    $('[data-quickview-modal] .product__info-container h3.product__text').focus();
    $('body').addClass('quickViewModal');
    _theme.Wishlist.init();
    Shopify.PaymentButton && Shopify.PaymentButton.init();

    $('#model--quickview .product__media-item.slick-slide').attr('tabindex', '-1');
    if ('#model--quickview .product-thumb-slider li'.length) {
      $('#model--quickview .product-thumb-slider li button').removeAttr('tabindex');
    }
    _theme.focusTrap($('#model--quickview'), function () {
      $('.ajax-quickview .close-modal').click();
    });
  }

  function emptyQV() {
    $('[data-quickview-modal] .halo-modal-body').empty();
  }
  function initQuickViewSlick() {
    setTimeout(function () {
      const imgSlickContainer = $('.offer-quickview-slider ul');
      imgSlickContainer.on('init', function (event, slick, currentSlide, nextSlide) {
        imgSlickContainer.closest('.offer-quickview-slider').removeClass('loading');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 1000);
      });
      imgSlickContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        arrows: true,
        prevArrow:
          "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'><span class='sr-only'>Previous</span></button>",
        nextArrow:
          "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'><span class='sr-only'>Next</span></button>",
      });
      $('.offer-quickview-slider ul .slick-list .slick-track').attr('role', 'presentation');
    }, 500);
  }

  return { init: init };
})();

_theme.MiniCart = (function () {
  let activeLineIndex = null,
    activeOperation = null;
  if ($('#dropdown-cart').length === 0) return;
  let offerConfig = JSON.parse($('#dropdown-cart').attr('data-config')) || null;

  function init() {
    $('[data-cart-toggle]')
      .off()
      .on('click', function (evt) {
        _theme.toggleSideCart(1, null, false);
        _theme.focusTrap($('#dropdown-cart'), function () {
          _theme.toggleSideCart(false, null, false);
        });
      });

    $('#dropdown-cart .close-cart')
      .off()
      .on('click', function (evt) {
        _theme.toggleSideCart(false, null, false);
      });

    $('#dropdown-cart .mini-products-list .btn-remove')
      .off()
      .on('click', function (evt) {
        evt.preventDefault();

        const $parent = $(this).closest('li[line-index]');
        const lineIndex = $parent.attr('line-index');
        if (!lineIndex) return;

        const $input = $parent.find('input[name="updates[]"]');
        const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
        const qty = $input.length ? parseInt($input.val()) : totalQty;
        let finalQty = totalQty - qty;
        finalQty = finalQty < 0 ? 0 : finalQty;

        if ($input.length) $input.val(0);

        $(this).parent().find('.button').addClass('disabled');
        disableCartClick(true);
        _theme.toggleLoading(1);
        updateStatusAccessibility(lineIndex, 'remove', 'in-progress');
        _theme.Helpers.changeLineItemQty(lineIndex, finalQty, false, function (cart) {
          lineItemChangeCallBack(cart, function () {
            updateStatusAccessibility(lineIndex, 'remove', 'done', 1, cart);
          });
        });
      });

    $('#dropdown-cart .mini-products-list .quantity-box .button')
      .off()
      .on('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        evt.stopImmediatePropagation();

        const $parent = jQuery(this).closest('li[line-index]');
        const lineIndex = $parent.attr('line-index');
        if (!lineIndex) return;

        const totalQty = parseInt($parent.attr('data-total-qty')) || 0;
        const $input = $parent.find('input[name="updates[]"]');
        const isPlus = jQuery(this).hasClass('plus');
        let qty = parseInt($input.val()) || 0;
        let finalQty = isPlus ? totalQty + 1 : totalQty - 1;

        qty = isPlus ? (qty += 1) : (qty -= 1);
        qty = qty < 0 ? 0 : qty;
        finalQty = finalQty < 0 ? 0 : finalQty;
        $input.val(qty);

        if (qty === undefined || !lineIndex) return;

        if (isPlus) updateStatusAccessibility(lineIndex, 'plus', 'in-progress');
        else updateStatusAccessibility(lineIndex, 'minus', 'in-progress');

        // $(this).parent().find('.button').addClass('disabled');
        disableCartClick(true);
        _theme.toggleLoading(1);
        _theme.Helpers.changeLineItemQty(
          lineIndex,
          finalQty,
          false,
          function (cart) {
            lineItemChangeCallBack(cart, function () {
              if (finalQty) {
                const $cureentLineItemQty = $(
                  '#dropdown-cart .mini-products-list [line-index="' +
                    lineIndex +
                    '"] .quantity-box'
                );
                if (isPlus) {
                  updateStatusAccessibility(lineIndex, 'plus', 'done', 1, cart);
                  $cureentLineItemQty.find('.plus').focus();
                } else {
                  updateStatusAccessibility(lineIndex, 'minus', 'done', 1, cart);
                  $cureentLineItemQty.find('.minus').focus();
                }
              }
            });
          },
          function (err) {
            $('#minicart-sr-only').text('Something went wrong');
            setTimeout(() => {
              $('#minicart-sr-only').text('');
            }, 1000);
          }
        );
      });

    $('#dropdown-cart .mini-products-list .item--sizelist')
      .off('change')
      .on('change', function (evt) {
        const vid = $(this).val();
        const key = $(this).data('key');
        const qty = $(this).data('qty');
        const lineIndex = $(this).closest('[line-index]').attr('line-index');
        if (!vid || !key || !qty || !lineIndex) return;

        try {
          disableCartClick(true);
          _theme.toggleLoading(1);
          Shopify.addItem(vid, qty, function (data) {
            Shopify.removeItem(key, function (cart) {
              lineItemChangeCallBack(cart, function () {
                if (qty) {
                  const $cureentLineItemSelect = $(
                    '#dropdown-cart .mini-products-list [line-index="' +
                      lineIndex +
                      '"] .item--sizelist'
                  );
                  $cureentLineItemSelect.focus();
                }
              });
            });
          });
        } catch (err) {
          console.error(err);
        }
      });

    const minicartSelect = document.querySelectorAll('.minicartSelect');
    minicartSelect.forEach((selectorEl) => {
      if (selectorEl.childElementCount <= 1) {
        selectorEl.classList.add('hidden');
        selectorEl.nextElementSibling.classList.remove('hidden');
      }
    });

    $(document).on('click', '.css-6331ag', function () {
      $('#dropdown-cart [data-block-freegift] #basket_samples').toggleClass('hidden');
    });

    initFreeGWP();
    initAutoFreeGift();
    initGwpModaltToggle();
  }

  function lineItemChangeCallBack(cart, callback) {
    if (cart) {
      offerConfig.cart_total_amt = Math.floor(cart.total_price / 100);
      jQuery('[data-cart-count]').text(cart.item_count);
    }
    $('.cart_count, [data-cart-count]').text(cart.item_count);

    if ($('[data-cart-count]').text() != 0) {
      $('.cart-icon.cart-handler-header').removeClass('cart-empty-icon');
    } else {
      $('.cart-icon.cart-handler-header').addClass('cart-empty-icon');
      $('[data-cart-count]').text('');
    }

    const $DropdownCart = $('#dropdown-cart');
    if (cart.item_count === 0) {
      $DropdownCart.addClass('cart--empty');
      if ($('.empty-cart-coll-slider').hasClass('slick-initialized')) {
        $('.empty-cart-coll-slider').slick('refresh');
      }
      $('.cart_item_text').text('Items');
      _theme.toggleLoading();
      disableCartClick(true);
      _theme.focusTrap($('#dropdown-cart'), function () {
        _theme.toggleSideCart(false, null, false);
      });
      $('#dropdown-cart .text-continue .new-cart-btn').attr({ tabindex: '0' }).focus();
      $('#dropdown-cart .cart_empty').attr({ role: 'alert' });
    } else {
      $.ajax({
        type: 'get',
        url: '/cart/?view=minicart',
        success: function (data) {
          const cartJson = JSON.parse($(data).find('[data-cartjson]').text()) || null;
          offerConfig = JSON.parse($(data).find('[data-offerjson]').text()) || null;

          $DropdownCart
            .find('.mini-products-list')
            .replaceWith($(data).find('.mini-products-list'));
          $DropdownCart.find('.summary').replaceWith($(data).find('.summary'));

          $('.cart_item_text').text(cartJson.item_count > 1 ? 'Items' : 'Items');
          $DropdownCart.removeClass('cart--empty');
          $DropdownCart.find('.quantity-box .button').removeClass('disabled');
          disableCartClick(false);
          _theme.toggleLoading();
          $('.cartCountAcc').text(' Cart with  ' + cartJson.item_count + ' items');

          init();

          if (callback && typeof callback === 'function') callback(cartJson);
          else {
            if (activeLineIndex) {
              if (activeOperation === 'plus')
                updateStatusAccessibility(activeLineIndex, 'plus', 'done', 1, cartJson);
              else updateStatusAccessibility(activeLineIndex, 'minus', 'done', 1, cartJson);
            }
          }
        },
        error: function () {
          disableCartClick(false);
          _theme.toggleAjaxModal(1, $.parseJSON(err.responseText).description);
          _theme.toggleLoading();
        },
      });
    }
  }

  function disableCartClick(disable) {
    if (disable) $('#dropdown-cart').addClass('processing');
    else $('#dropdown-cart').removeClass('processing');
  }

  function initFreeGWP() {
    const isAdded =
      $('.mini-products-list .regular-line-item[data-free-added="true"]').length > 0 ? true : false;
    if (isAdded) {
      if (offerConfig.cart_total_amt < offerConfig.free_gwp_min_amount || !offerConfig.free_gwp) {
        $('body').addClass('disable-free-products');
        const vid = parseInt(
          $('.mini-products-list .regular-line-item[data-free-added="true"]').attr('data-varid')
        );
        if (!vid) return;

        _theme.Helpers.changeLineItemQty(vid, 0, 1, lineItemChangeCallBack);
      } else {
        // Remove product
        $('[data-block-freegift] .cm-remove-btn').click(function (evt) {
          const vid = $(this).data('varid');
          if (!vid) return;

          _theme.toggleLoading(1);
          disableCartClick(false);
          _theme.Helpers.changeLineItemQty(vid, 0, 1, lineItemChangeCallBack);
        });
        // Update product
        $('[data-block-freegift] .cm-add-btn').click(function (evt) {
          const isGiftAdded =
            $('.mini-products-list .regular-line-item[data-free-added="true"]').length > 0
              ? true
              : false;
          if (isGiftAdded) {
            const vidNew = $(this).data('varid');
            const vidOld = parseInt(
              $('.mini-products-list .regular-line-item[data-free-added="true"]').attr('data-varid')
            );
            if (!vidOld && vidNew) return;

            _theme.Helpers.changeLineItemQty(vidOld, 0, 1, function () {
              try {
                if (offerConfig.cart_total_amt >= offerConfig.free_gwp_min_amount) {
                  disableCartClick(false);
                  const properties = {
                    _type: 'gwp',
                    _discAmount: '0',
                  };
                  _theme.Helpers.addProductToCart(vidNew, 1, properties, function () {
                    Shopify.getCart(function (cartdata) {
                      lineItemChangeCallBack(cartdata);
                    });
                  });
                }
              } catch (err) {
                console.error(err);
              }
            });
          }
        });
        // To remove the high threshold product
        if (isAdded) {
          const oldGwpId = $('.mini-products-list .regular-line-item[data-free-added="true"]').attr(
            'data-varid'
          );
          if (!oldGwpId) return;

          const oldGwpExist =
            $(`#basket_samples .freegiftproitem[data-varid="${oldGwpId}"]`).length > 0;
          if (!oldGwpExist) {
            _theme.Helpers.changeLineItemQty(oldGwpId, 0, 1, lineItemChangeCallBack);
          }
        }
      }
    } else {
      if (offerConfig.free_gwp && !offerConfig.auto_free_gift) {
        if (offerConfig.cart_total_amt < offerConfig.free_gwp_min_amount) {
          $('body').addClass('disable-free-products');
        } else {
          $('body').removeClass('disable-free-products');
        }
      }
      // Add product
      $('[data-block-freegift] .cm-add-btn').click(function (evt) {
        const isGiftAdded =
          $('.mini-products-list .regular-line-item[data-free-added="true"]').length > 0
            ? true
            : false;
        console.log('isGiftAdded==>', isGiftAdded);
        if (isGiftAdded) {
          _theme.toggleAjaxModal(1, 'Gift product is already added');
          return;
        }

        try {
          const config = $(this).closest('[data-block-freegift]').data('config');
          const vid = $(this).data('varid');
          if (offerConfig.cart_total_amt >= offerConfig.free_gwp_min_amount) {
            disableCartClick(false);
            const properties = {
              _type: 'gwp',
              _discAmount: '0',
            };
            _theme.Helpers.addProductToCart(vid, 1, properties, function () {
              Shopify.getCart(function (cartdata) {
                lineItemChangeCallBack(cartdata);
              });
            });
          } else {
            _theme.toggleAjaxModal(
              1,
              'Offer is only applicable over ' +
                Shopify.formatMoney(config.free_gwp_min_amount * 100)
            );
          }
        } catch (err) {
          console.error(err);
        }
      });
    }
  }

  let isFreeGiftInProgress = false;

  function initAutoFreeGift() {
    if (isFreeGiftInProgress) {
      console.log('Free gift update in progress, skipping...');
      return;
    }

    isFreeGiftInProgress = true;

    Shopify.getCart(function (cart) {
      const freeGiftItems = cart.items.filter((item) => {
        return item.properties && item.properties._proType === 'freeGift';
      });

      const hasFreeGift = freeGiftItems.length > 0;
      const totalFreeGiftQty = freeGiftItems.reduce((acc, item) => acc + item.quantity, 0);

      // Remove free gift if not eligible
      if (
        hasFreeGift &&
        (offerConfig.cart_total_amt < offerConfig.auto_free_gift_min_amount ||
          !offerConfig.auto_free_gift)
      ) {
        removeAllFreeGifts(freeGiftItems);
        return;
      }

      // More than 1 free gift — trim down to 1
      if (hasFreeGift && totalFreeGiftQty > 1) {
        adjustFreeGiftQty(freeGiftItems[0]);
        return;
      }

      // No free gift yet, but eligible → add it
      if (
        !hasFreeGift &&
        offerConfig.auto_free_gift &&
        offerConfig.cart_total_amt >= offerConfig.auto_free_gift_min_amount
      ) {
        _theme.Helpers.addProductToCart(offerConfig.auto_free_gift_vid, 1, 'freeGift', function () {
          Shopify.getCart(function (newCart) {
            lineItemChangeCallBack(newCart);
            isFreeGiftInProgress = false;
          });
        });
      } else {
        isFreeGiftInProgress = false;
      }
    });
  }

  function removeAllFreeGifts(freeGiftItems) {
    let removeCount = freeGiftItems.length;
    freeGiftItems.forEach((item) => {
      _theme.Helpers.changeLineItemQty(item.variant_id, 0, item.quantity, () => {
        removeCount--;
        if (removeCount === 0) {
          Shopify.getCart(function (updatedCart) {
            lineItemChangeCallBack(updatedCart);
            isFreeGiftInProgress = false;
          });
        }
      });
    });
  }

  function adjustFreeGiftQty(item) {
    _theme.Helpers.changeLineItemQty(item.variant_id, 1, 1, () => {
      Shopify.getCart(function (updatedCart) {
        lineItemChangeCallBack(updatedCart);
        isFreeGiftInProgress = false;
      });
    });
  }

  function updateStatusAccessibility(lineIndex, operation, status, shouldEmpty, cart) {
    const miniCartSrOnly = $('#minicart-sr-only');
    const $lineitemElem = $(
      '#dropdown-cart .mini-products-list .item[line-index="' + lineIndex + '"]'
    );
    if (!lineIndex) $('[data-aria-live]').text('');
    if (!lineIndex || !operation) return;

    if (status === 'in-progress') {
      activeLineIndex = lineIndex;
      if (operation === 'plus') {
        miniCartSrOnly.text('please wait. increasing quantity');
        activeOperation = 'plus';
      } else if (operation === 'remove') {
        miniCartSrOnly.text('please wait. removing item from the cart');
      } else {
        miniCartSrOnly.text('please wait. decreasing quantity');
        activeOperation = 'minus';
      }
    }

    if (status === 'done') {
      // console.log(cart);
      if (cart && cart.item_count > 0) {
        if (operation === 'plus') {
          miniCartSrOnly.text('Increased successfully by 1');
        } else if (operation == 'remove') {
          miniCartSrOnly.text('Item successfully removed from the cart');
        } else miniCartSrOnly.text('Decreased successfully by 1');

        if ($lineitemElem.length > 0) {
          $lineitemElem.find('[data-block-qty] .plus').focus();
        }
        _theme.focusTrap($('#dropdown-cart'), function () {
          _theme.toggleSideCart(false, null, false);
        });
      } else {
        _theme.focusTrap($('#dropdown-cart'), function () {
          _theme.toggleSideCart(false, null, false);
        });
        $('#dropdown-cart .text-continue .new-cart-btn').attr({ tabindex: '0' }).focus();
        $('#dropdown-cart .cart_empty').attr({ role: 'alert' });
      }

      activeLineIndex = null;
      activeOperation = null;
    }

    if (shouldEmpty) {
      setTimeout(function () {
        miniCartSrOnly.text('');
      }, 2000);
    }
  }

  function initGwpModaltToggle() {
    $(document)
      .off('click', '.css-6331ag')
      .on('click', '.css-6331ag', function () {
        const $element = $('#dropdown-cart [data-block-freegift] #basket_samples');
        $element.toggleClass('hidden');
      });
  }

  return {
    init: init,
    lineItemChangeCallBack: lineItemChangeCallBack,
  };
})();

_theme.MiniCartQuickview = (function () {
  const cache_product = {};
  let $activeElem = null;

  function init() {
    $('#dropdown-cart').removeClass('hidden');

    $('.sidecart-qv .sidecart-qv-close').click(function (a) {
      a.preventDefault(),
        $(this).closest('.sidecart-qv').removeAttr('data-id'),
        _theme.toggleSideCartQv();
      if ($activeElem) $activeElem.focus();
      $activeElem = null;
      $('.wrapper-overlay').removeClass('active');
      if ($('html').hasClass('cart-show') || $('body').hasClass('template-cart')) {
        $('.wrapper-overlay').addClass('active');
      }
    });

    $(document).on('click', '.sidecart-qv-close.offer-sidecart-qv-close', function (event) {
      event.preventDefault();
      $(this).closest('.sidecart-qv').removeAttr('data-id');
      _theme.toggleSideCartQv();
      $('.wrapper-overlay').removeClass('active');
      const cart_offer_list = document.querySelector('cart-offer-list.product_active');

      if (cart_offer_list) {
        cart_offer_list.classList.remove('product_active');
      }

      if ($('html').hasClass('cart-show') || $('body').hasClass('template-cart')) {
        $('.wrapper-overlay').addClass('active');
      }

      // $('.cart-offer-container').hide();
    });

    $('.sidecart-qv').on('click', '.product_bottom .accordion-item .tab-title', function (a) {
      $(this).toggleClass('open').next('.tab-content').stop().slideToggle();
    });

    $('#dropdown-cart .cart-recommended-products [data-sidecartqv], .section-recommended-products-container [data-sidecartqv]')
      .off('click')
      .on('click touchend', function (e) {
        e.preventDefault();
        const $self = $(this);
        $activeElem = $self;
        const prod_url = $(this).data('url');
        const prod_id = $(this).data('id');
        if (!prod_url || !prod_id) return;

        handleQVClick(prod_url, prod_id);
      });

    $(document).on('click', '.sidecart-qv .sidecart-qv-inner button.cta-atc', function (c) {
      _theme.focusTrap($('#dropdown-cart'), function () {
        _theme.toggleSideCart(false, null, false);
      });
      c.preventDefault();

      // Do Not Remove Code - Add Properties for GWP Discount
      const properties = {};
      const bundleVarIdElement = $(this)
        .closest('.offer-quickview-footer')
        .find('[data-bundleVarId]');
      if (bundleVarIdElement.length > 0) {
        properties['_bundleVarId'] = bundleVarIdElement.val() || null;
      }
      // Do Not Remove Code - Add Properties for GWP Discount

      const d = $(this),
        a = getCurrentVariant(),
        b = d.closest('.sidecart-qv'),
        e = b.find('form'),
        g = b.attr('data-id');
      if ($('.offer-quickview-footer .quantity__select').length) {
        var f = b.find('.offer-quickview-footer .quantity__select').val();
      } else {
        var f = b.find('.sidecart-qv-quantity-wrapper input[name="quantity"]').val();
      }
      b.find('.offer-quickview-footer').addClass('disabled');
      a &&
        ($(this).addClass('loading'),
        _theme.toggleLoading(1),
        handleAddToCart(a.id, f, properties, function (a) {
          itemAddedCallBack(a, d);
          const b = $('#dropdown-cart .cart-recommended-products button[data-id="' + g + '"]');
          if ($('.offer-quickview-footer .quantity__select').length) {
            $('.wrapper-overlay').removeClass('active');
            _theme.toggleSideCart(1, null, true);
          }
          b.find('.offer-quickview-footer').removeClass('disabled');
          b.addClass('added').find('text').text('Added'),
            _theme.toggleSideCartQv(),
            setTimeout(function () {
              b.removeClass('added').find('text').text('Quick view');
            }, 3e3);
        }));
    });

    $(document).on('click', '.sidecart-qv .sidecart-qv-quantity-wrapper span', function (d) {
      let b = $(this).parent().find('input[type="number"]'),
        c = $(this).closest('.sidecart-qv-quantity').find('.sidecart-qv-current-qty'),
        a = Number(b.val());
      $(this).hasClass('sidecart-qv-qty-minus') ? (a -= 1) : (a += 1),
        (a = a < 1 ? 1 : a),
        b.val(a),
        c.text(a);
    });

    $(document).on('keyup', '.sidecart-qv .sidecart-qv-quantity-wrapper span', function (evt) {
      if (evt.key.toUpperCase() === 'ENTER') {
        evt.target.click();
      }
    });

    $(document).on('change', '.sidecart-qv .sidecart-qv-options input[type="radio"]', function (l) {
      const b = getCurrentVariant();
      if (b) {
        const a = $('.sidecart-qv');
        a.find('form');
        const c = a.find('.sidecart-qv-inner button.cta-atc'),
          f = a.find('.sidecart-qv-price.on-sale'),
          d = a.find('.sidecart-qv-compare-price'),
          e = a.find('.sidecart-qv-per-off');
        a.find('.sidecart-qv-klarna');
        const g = a.data('klarna-split'),
          h = Number(a.data('klarna-min')),
          i = b.price / 100 / g;
        if (
          (b.available
            ? c
                .removeClass('disabled')
                .removeAttr('disabled')
                .text(window.inventory_text.add_to_cart)
            : c
                .text(window.inventory_text.sold_out)
                .addClass('disabled')
                .attr('disabled', 'disabled'),
          f.html(
            '<span class="visually-hidden">Sale Price</span>' +
              Shopify.formatMoney(b.price, Shopify.money_format)
          ),
          b.compare_at_price && b.compare_at_price > b.price)
        ) {
          d.removeClass('hidden').html(
            '<span class="visually-hidden">Regular Price</span>' +
              Shopify.formatMoney(b.compare_at_price, Shopify.money_format)
          );
          const j = Shopify.formatMoney(b.compare_at_price - b.price, Shopify.money_format);
          e.removeClass('hidden').html(
            'Save ' + j + '<span class="visually-hidden">Discount</span>'
          );
        } else d.addClass('hidden'), e.addClass('hidden');
        if (h < b.price) {
          const k = Shopify.formatMoney(i.toFixed(2), Shopify.money_format);
          a.find('[data-id="klarnaEmiAmount"]').text(k),
            a.find('[data-id="klarnaNonAvailabilityMessage"]').css('display', 'none'),
            a.find('[data-id="klarnaAmountContainer"]').css('display', 'inline');
        } else
          a.find('[data-id="klarnaAmountContainer"]').css('display', 'none'),
            a.find('[data-id="klarnaNonAvailabilityMessage"]').css('display', 'inline');
        _theme.refreshKlarna();

        const selectEle = a.find('.sidecart-qv-footer [data-quantity-select]');
        selectEle.empty();
        for (let i = 1; i <= 10; i++) {
          const option = $('<option></option>');
          option.val(i).text(i);
          if (i > b.inventory_quantity) {
            option.prop('disabled', true);
          }
          selectEle.append(option);
        }
      }
    });
  }

  async function handleQVClick(prod_url, prod_id, variantId) {
    if (!prod_url || !prod_id) return;

    let product_url = prod_url;
    if (variantId) product_url += '?variant=' + variantId;
    product_url += (product_url.includes('?') ? '&' : '?') + 'view=sidecart-qv';
    _theme.toggleLoading(1);

    if (cache_product[prod_id]) {
      updateSideCartQv(cache_product[prod_id].html, prod_id);
    } else {
      try {
        const resp = await fetch(product_url);
        const text = await resp.text();
        cache_product[prod_id] = { html: text };
        updateSideCartQv(text, prod_id);
      } catch (error) {
        console.log(a), _theme.toggleLoading();
        $self.removeClass('loading');
        alert('Something went wrong. Please try again later');
      } finally {
        _theme.toggleLoading();
      }
    }
  }

  function updateSideCartQv(res, prod_id) {
    const parser = new DOMParser();
    const html = parser.parseFromString(res, 'text/html');
    const body = html.querySelector('body');

    $('.sidecart-qv').attr('data-id', prod_id);
    $('.sidecart-qv .sidecart-qv-body').html($(body).find('.pdp-sidecart-qv-body').html());

    setTimeout(function () {
      const imgSlickContainer = $('.sidecart-qv .sidecart-qv-images ul');

      imgSlickContainer.on('init', function (event, slick, currentSlide, nextSlide) {
        imgSlickContainer.closest('.sidecart-qv-images').removeClass('loading');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        slick.$slider.find('.slick-slide').removeAttr('tabindex');

        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
        }, 1000);
      });

      imgSlickContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: !1,
        arrows: true,
        // prevArrow: "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
        // nextArrow: "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>"
      });
      $('.sidecart-qv-inner .sidecart-qv-images .slick-list .slick-track').attr(
        'role',
        'presentation'
      );
    }, 1000);

    // $(".sidecart-qv .sidecart-qv-options .swatch-element.available").first().find("input").prop("checked", true);
    _theme.toggleSideCartQv(1);
    _theme.initSmartWishlist();
    _theme.toggleLoading();
    _theme.refreshKlarna();

    _theme.focusTrap(
      $('.sidecart-qv'),
      function () {
        _theme.toggleSideCartQv();
        if ($activeElem) $activeElem.focus();
        $activeElem = null;
      },
      'details'
    );
  }

  function getCurrentVariant() {
    const b = $('.sidecart-qv'),
      c = b.find('form');
    if (c.find('.sidecart-qv-options input:checked').val()) {
      let d = null;
      try {
        const a = JSON.parse(b.find('.sidecart-qv-body script[data-json]').text());
        if (!a.available) return;
        const f = {},
          g = a.options.length;
        c.find('.sidecart-qv-options .swatch').each(function () {
          f['option' + (parseInt($(this).attr('data-option-index')) + 1)] = $(this)
            .find('input:checked')
            .val();
        }),
          (d =
            a.variants.length > 1
              ? a.variants.filter(function (a) {
                  switch (g) {
                    case 1:
                      return f.option1 == a.option1;
                    case 2:
                      return f.option1 == a.option1 && f.option2 == a.option2;
                    case 3:
                      return (
                        f.option1 == a.option1 && f.option2 == a.option2 && f.option3 == a.option3
                      );
                  }
                })[0]
              : a.variants[0]);
      } catch (e) {
        console.log(e);
      }
      return d || null;
    }
  }

  _theme.CollectionAddToCart = function () {
    $(document).on(
      'click',
      '.product-quick-add .product-quick-add--variants button.quick-add-v.available',
      function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        const vid = $(this).data('vid');
        if (!vid) return;
        const $status = $('#quick-add-accessibility-status');
        $status.text('Please wait, adding product to the cart');
        const $parent = $(this).closest('.quick-add-gr');
        _theme.toggleLoading(1);
        $parent.addClass('loading');

        // track event
        const productTitle = $(this).data('product-title');
        const variantTitle = $(this).data('variant-title');
        const variantPrice = $(this).data('variant-price');
        _theme.track.trackQuickView({
          productTitle: productTitle,
          variantTitle: variantTitle,
          variantPrice: variantPrice,
        });

        _theme.Helpers.addItem(
          vid,
          1,
          function () {
            _theme.toggleLoading();
            $parent.removeClass('loading');
            $status.text('product added successfully');
            setTimeout(function () {
              $status.text('');
            }, 2500);
            _theme.focusTrap($('#dropdown-cart'), function () {
              _theme.toggleSideCart(false, null, false);
            });
          },
          1
        );
      }
    );
  };

  function handleAddToCart(a, b, p, c) {
    _theme.Helpers.addProductToCart(
      a,
      b,
      p,
      (resp) => {
        _theme.MiniCart.lineItemChangeCallBack(resp, function () {
          _theme.toggleLoading();
          _theme.toggleSideCart(1, null, true);
        });

        // Call the original callback (if provided)
        if (c && typeof c === 'function') {
          c(resp);
        }
      },
      (err) => {
        console.error(err);
      },
      1
    );
  }

  function itemAddedCallBack(cart, b) {
    _theme.MiniCart.lineItemChangeCallBack(cart);
    $('[data-cart-count]').text(cart.item_count);
    b.removeClass('loading');
    $('#dropdown-cart .error-box').hide();
    $('#dropdown-cart .item-added-note').removeClass('hidden');
    _theme.toggleLoading();
    _theme.toggleSideCartQv();
  }

  return {
    init: init,
    handleQVClick: handleQVClick,
  };
})();

_theme.ScrollEvent = (function () {
  const headerOff = $('header.site-header').offset().top;
  let prevScroll = 0;
  function init() {
    $(window).scroll(function () {
      const scrollTop = $(this).scrollTop();
      if (scrollTop > 100) $('[data-backtotop]').addClass('active');
      else $('[data-backtotop]').removeClass('active');

      if (scrollTop > headerOff) {
        $('body').addClass('header-fixed');
        if (prevScroll > scrollTop) {
          $('body').addClass('scroll-up');
        } else {
          $('body').removeClass('scroll-up');
        }
      } else {
        $('body').removeClass('header-fixed scroll-up');
      }
      prevScroll = scrollTop;
    });
    //Click event to scroll to top
    $('[data-backtotop]').click(function () {
      $('html, body').animate({ scrollTop: 0 }, 500);
      $('.skip-to-content-link').focus();
      return false;
    });
    $('[data-backtotop]').keyup(function (evt) {
      if (evt.key.toUpperCase() === 'ENTER') {
        evt.target.click();
      }
    });
  }
  return { init: init };
})();

_theme.Newsletter = (function () {
  function init() {
    const formPosted = _theme.Helpers.getParamFromURL('customer_posted');
    if (formPosted && window.gtag) {
      gtag('event', 'subscribe_newsletter', { method: 'Footer' });
      setTimeout(() => {
        _theme.track.trackData({ event: 'newsletterSubscribed' });
      }, 500);
    }
    const alreadySubscribed = _theme.Helpers.getParamFromURL('form_type');
    if (!formPosted && !(alreadySubscribed == 'customer')) return;

    const popup = !formPosted
      ? $('.newsletter-success-modal.already-subscribed')
      : $('.newsletter-success-modal.not-yet-subscribed');
    const close = popup.find('.close');
    const overlay = popup.find('.modal-overlay');
    popup.show();
    setTimeout(function () {
      $('.newsletter-success-modal').focus();
    });
    $.cookie('emailSubcribeModal', 'closed', {
      expires: 1,
      path: '/',
    });
    close.off('click').on('click', function () {
      popup.fadeOut();
      $('.skip-to-maincontent.show').focus();
    });
    overlay.off('click').on('click', function () {
      popup.fadeOut();
      $('.skip-to-maincontent.show').focus();
    });
    const newURL = !formPosted
      ? _theme.Helpers.deleteParamFromURL('form_type')
      : _theme.Helpers.deleteParamFromURL('customer_posted');
    history.replaceState('', '', newURL);
  }

  return { init: init };
})();

_theme.ProductRecommendations = (function () {
  const selectors = {
    productCard: '[data-product-card]',
  };

  function ProductRecommendations(container, sliderSettings) {
    this.$container = $(container);
    if (this.$container.length === 0) return;

    const self = this;
    const productId = this.$container.data('productid');
    const limit = this.$container.data('limit') || 6;
    const sec_name = this.$container.data('section-type') || 'product-recommendations';
    const recommendationsSectionUrl =
      '/recommendations/products?&section_id=' +
      sec_name +
      '&product_id=' +
      productId +
      '&limit=' +
      limit;

    $.get(recommendationsSectionUrl).then(
      function (section) {
        const recommendationsMarkup = $(section).find(container).length
          ? $(section).find(container).html()
          : $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);

          self.initSlider(sliderSettings);
        }
      }.bind(this)
    );
  }

  ProductRecommendations.prototype.initSlider = function (sliderSettings) {
    const slickSettings = sliderSettings || {
      infinite: false,
      speed: 300,
      arrows: true,
      // prevArrow: "<button type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'><span class='visually-hidden'>Prev</span></button>",
      // nextArrow: "<button type='button' class='slick-arrow slick-next'><i class='arrow1 right1'><span class='visually-hidden'>Next</span></button>",
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 2.3, slidesToScroll: 2 },
        },
        {
          breakpoint: 767,
          settings: { slidesToShow: 2.05, slidesToScroll: 2, arrows: true },
        },
        { breakpoint: 345, settings: { slidesToShow: 2, slidesToScroll: 2, arrows: true } },
      ],
    };

    const $slider = this.$container.find('[data-product-wrapper]');
    const $sliderCart = this.$container.find('.featured-slider2');

    _theme.initSlickSlider(
      $sliderCart,
      slickSettings,
      function (slick) {
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        slick.$slider.find('.slick-slide').find('.smartwishlist').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"]')
          .find('.smartwishlist')
          .attr('tabindex', -1);
        setTimeout(function () {
          slick.$slider.find('.slick-slide').find('.smartwishlist').removeAttr('tabindex');
          slick.$slider
            .find('.slick-slide[aria-hidden="true"]')
            .find('.smartwishlist')
            .attr('tabindex', -1);
        }, 4000);
      },
      function (slick) {
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      }
    );

    if ($slider.find('.grid__item').length > 3) {
      _theme.initSlickSlider(
        $slider,
        slickSettings,
        function (slick) {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        },
        function (slick) {
          slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
        }
      );
    }
    // $slider.on('init beforeChange afterChange', function(event, slick, currentSlide, nextSlide){});
    // $slider.slick(slickSettings);

    $slider.on('init afterChange beforeChange', function (event, slick, currentSlide, nextSlide) {
      slick.$slider
        .find('.slick-slide[aria-hidden="true"]')
        .find('.smartwishlist')
        .attr('tabindex', 0);
      slick.$slider
        .find('.slick-slide[aria-hidden="false"]')
        .find('.smartwishlist')
        .attr('tabindex', -1);
    });
    setTimeout(() => {
      $slider.on('init afterChange beforeChange', function (event, slick, currentSlide, nextSlide) {
        slick.$slider
          .find('.slick-slide[aria-hidden="true"]')
          .find('.smartwishlist')
          .attr('tabindex', 0);
        slick.$slider
          .find('.slick-slide[aria-hidden="false"]')
          .find('.smartwishlist')
          .attr('tabindex', -1);
      });
    }, 2000);

    const sliderInterval = setInterval(() => {
      const productWrapper = $('#product-recommendations [data-product-wrapper]');
      const isSliderInitialized = productWrapper.hasClass('slick-initialized');
      if (isSliderInitialized) {
        productWrapper.find('.slick-slide').each(function () {
          if ($(this).attr('aria-hidden') === 'true') {
            $(this).find('.smartwishlist').attr('tabindex', -1);
          } else {
            $(this).find('.smartwishlist').attr('tabindex', 0);
          }
          setTimeout(() => {
            if ($(this).attr('aria-hidden') === 'true') {
              $(this).find('.smartwishlist').attr('tabindex', -1);
            } else {
              $(this).find('.smartwishlist').attr('tabindex', 0);
            }
          }, 5000);
        });
        clearInterval(sliderInterval);
      }
    }, 100);
  };

  return ProductRecommendations;
})();

_theme.initSliderRelatedProducts = function () {
  $('.new-grid-slider').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: false,
          slidesToShow: 2.3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });
};

_theme.quickAdd = function () {
  if ($('.inner.product-item .product-quick-add').length === 0) return;

  const isAccountPage = document.querySelector('body.template-customers-account');
  $(
    '.inner.product-item .product-quick-add .product-quick-add--variants:not(.slick-initialized)'
  ).each(function () {
    const $this = $(this);
    const limit = isAccountPage ? 2 : 3;
    if ($this.find('button').length < limit) return;
    if ($this.hasClass('slick-initialized')) $this.slick('unslick');

    $this.on('init beforeChange afterChange', function (event, slick, currentSlide, nextSlide) {
      slick.$slider.find('button.slick-arrow').attr('tabindex', 0);
      slick.$slider.find('button.slick-arrow[aria-disabled="true"]').attr('tabindex', -1);
    });

    $this.slick({
      accessibility: true,
      rows: 0,
      infinite: false,
      arrows: true,
      slidesToShow: isAccountPage ? 1 : 2,
      slidesToScroll: 1,
      arrows: true,
      // prevArrow: '<button class="outline-inverse slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true" tabindex="-1">&lt;</button>',
      // nextArrow: '<button class="outline-inverse slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false" tabindex="0">&gt;</button>'
    });
  });
};

window.Shopify = window.Shopify || {};
Shopify.onError = function (t, r) {
  const e = eval('(' + t.responseText + ')');
  e.message
    ? alert(e.message + '(' + e.status + '): ' + e.description)
    : alert('Error : ' + Shopify.fullMessagesFromErrors(e).join('; ') + '.');
  _theme.toggleLoading();
  $('.wishlist-items, .quick-add-gr').removeClass('loading');
};

// ;(function(){
//   const oSClass = 'device--' + _theme.getOS();
//   const deviceClass = 'device--' + _theme.getOS() + '-v-' + _theme.iPhoneVersion();
//   const selector = document.querySelector('html');
//   const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
//   selector.classList.add(oSClass);
//   selector.classList.add(deviceClass);
// })();

_theme.toggleRewardModel = function (newURL) {
  const smileContainer = document.querySelector('#smile-ui-container');
  if (!smileContainer || !newURL) return;

  if (newURL.indexOf('#smile') > -1) {
    smileContainer.classList.remove('hidden');
    smileContainer.classList.add('active');
  } else {
    smileContainer.classList.add('hidden');
    smileContainer.classList.remove('active');
  }
};

_theme.handleADA = function (delay) {
  const footerBeListInterval = setInterval(function () {
    const beList = document.querySelector('.footer-bottom ul.be-list');
    if (beList) {
      beList.setAttribute('role', 'list');
      beList.querySelectorAll('li').forEach(function (li) {
        li.setAttribute('role', 'listitem');
      });
      clearInterval(footerBeListInterval);
    }
  }, 1000);

  setTimeout(function () {
    if (footerBeListInterval) clearInterval(footerBeListInterval);
  }, 8000);
};

$(function () {
  _theme.loadSection();
  _theme.removeElements();
  _theme.initSlideShow();
  _theme.initHorizontalScroll();
  _theme.initPriceOff();
  _theme.initSmartWishlist();
  _theme.MiniCart && _theme.MiniCart.init && _theme.MiniCart.init();
  _theme.MiniCartQuickview.init();
  _theme.ProductGridQuickView.init();
  _theme.ScrollEvent.init();
  _theme.Newsletter.init();
  // _theme.initGTM();
  _theme.setMinicartHeight();
  _theme.updateDOMOnResize();
  _theme.CollectionAddToCart();
  _theme.quickAdd();
  _theme.footerPaneEvents();
  _theme.handleADA();
  _theme.toggleRewardModel(window.location.href);
  _theme.pushBackButton.init();

  window.addEventListener('hashchange', function (evt) {
    _theme.toggleRewardModel(evt.newURL);
  });

  if (window.navigation) {
    window.navigation.addEventListener('navigate', function (e) {
      _theme.toggleRewardModel(e && e.destination && e.destination.url);
    });
  }

  setTimeout(_theme.initHeaderEvetns, 1000);
  setTimeout(_theme.initLazyloadData, 1000);
  if ($('body.template-cart').length) {
    new _theme.ProductRecommendations('[data-recommendations]');
  }
});

$(window).on('load', function () {
  _theme.loadAppScript();
  _theme.checkQuickViewRating(1000);

  if ($('.account-page [data-block-wishlist]').length) {
    const wishInterval = setInterval(function () {
      if (window.SWGetExpressWishlistId) {
        clearInterval(wishInterval);
        _theme.buildhWishlistGrid('.section-wishlist .wishlist-items');
      }
    }, 500);

    setTimeout(function () {
      if (wishInterval) clearInterval(wishInterval);
    }, 15000);
  }

  // $('body').on('click', '.snize-ac-results-content', function (e) {
  //   e.stopPropagation()
  // });
  // $('body').on('click', '.snize-ac-results', function (e) {
  //   $('.snize-ac-results').attr('style', 'display:none !important;visibility:hidden !important')
  // });
});
$(document).ready(function () {
  const value = $('.checkres').data('res');
  if (value == true) {
    $('.resetsuccessMessage').show();
    $('.resetsuccessMessage').focus();
    $('.showRecoverPasswordForm').on('click', function () {
      $('.resetsuccessMessage').hide();
    });
  }
});
$(document).ready(function () {
  window.addEventListener('scroll', () => {
    const headerOptions = document.querySelector('.uitityHeader .main-header-new');
    const headerOffset = headerOptions.offsetTop;
    const getBody = document.querySelector('body');
    if (window.pageYOffset > 400) {
      headerOptions.classList.add('sticky');
      getBody.classList.add('topPad');
      getBody.classList.remove('non-stick');
      getBody.classList.remove('loadState');
    } else {
      headerOptions.classList.remove('sticky');
      getBody.classList.add('non-stick');
      getBody.classList.remove('topPad');
    }
  });

  setTimeout(function () {
    const darkSvg = $('#shopify-svg__payments-facebook-pay-dark');
    const lightSVg = $('#shopify-svg__payments-facebook-pay-light');

    if (lightSVg) {
      $('#shopify-svg__payments-facebook-pay-light').remove();
    }

    if (darkSvg) {
      $('#shopify-svg__payments-facebook-pay-dark').remove();
    }

    $('.bv-relevancy-popup-target').removeAttr('role');
    $('.bv-trustmarkIcon-popup-target').removeAttr('role');
  }, 4000);

  ///// Contact us form focus on success /////
  if (window.location.href.indexOf('contact_posted=true') > -1) {
    const contactFormNameElem = $('#contactFormWrapper #contactFormName');
    contactFormNameElem.focus();
  }

  if (window.location.href.indexOf('register') > -1) {
    const registerEmail = $('.col-right #first_name_login_page');
    registerEmail.focus();
  }
  //////

  (function () {
    let brandSlider1_arrow = false;
    if ($('.brands-slider1 > .item').length > 6) {
      brandSlider1_arrow = true;
    }

    _theme.initSlickSlider(
      $('.brands-slider1'),
      {
        infinite: false,
        arrows: brandSlider1_arrow,
        dots: false,
        // prevArrow: "<button type='button'  tabindex='-1'  class=\"slick-prev slider-slick-prev\" aria-label='previous'><i class='arrow1 left1'></button>",
        // nextArrow: "<button type='button' tabindex='0' class=\"slick-next slider-slick-next\" aria-label='next'><i class='arrow1 right1'></button>",
        slidesToShow: 6.6,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5.5,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 4.5,
              slidesToScroll: 1,
              arrows: true,
            },
          },
          {
            breakpoint: 568,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1,
              arrows: true,
            },
          },
        ],
      },
      null,
      (slick) => {
        const slidePerRow = _theme.isMobile ? 3 : 6;
        const colIndex = Math.ceil(slick.currentSlide / slidePerRow);
        _theme.track.trackView('Brands slider', colIndex);
      }
    );
  })();

  _theme.initSlickSlider($('.logo-brand-fathcoll .brands-slider1'), {
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  });

  _theme.initSlickSlider($('.trustpilot-review-right .gslider'), {
    infinite: false,
    arrows: true,
    // prevArrow: "<button aria-label='Previous' class=\"slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
    // nextArrow: "<button aria-label='Next' class=\"slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
          arrows: false,
          infinite: true,
          speed: 5000,
        },
      },
    ],
  });

  function initDeviceVaries() {
    if (window.innerWidth < 1024) {
      _theme.initSlickSlider($('.home-blog-posts-sections .justify-content-between'), {
        infinite: false,
        arrows: true,
        dots: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    } else {
      if ($('.home-blog-posts-sections .justify-content-between').hasClass('slick-initialized')) {
        setTimeout(function () {
          $('.home-blog-posts-sections .justify-content-between').slick('unslick');
        }, 1000);
      }
    }

    if (window.innerWidth > 767) {
      $('.logo-brand .brands-slider1 .item')
        .off()
        .on({
          mouseenter: function () {
            $(this).addClass('hover');
            $(this).closest('.logo-brand').addClass('hover');
          },
          mouseleave: function () {
            $(this).removeClass('hover');
            $(this).closest('.logo-brand').removeClass('hover');
          },
        });
    } else {
      const $advantageSectionSlider = $('.header-panel-bt-l.container.brands-slider-mobile');
      if ($advantageSectionSlider.hasClass('slick-initialized'))
        $advantageSectionSlider.slick('unslick');
      $advantageSectionSlider.on(
        'init beforeChange afterChange',
        function (event, slick, currentSlide, nextSlide) {
          setTimeout(function () {
            slick.$slider.find('.header-panel-bt-l-inner.slick-slide').removeAttr('aria-hidden');
          }, 100);
          setTimeout(function () {
            slick.$slider.find('.header-panel-bt-l-inner.slick-slide').removeAttr('aria-hidden');
          }, 250);
        }
      );

      $advantageSectionSlider.slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        // prevArrow: "<button class=\"slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
        // nextArrow: "<button class=\"slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 592,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      });
      // $('.site-header .header-mb-right .customer-links.search').click(function () {
      //   $(this).closest('.site-header').find('.header-mb-left.header-mb-items,.header-bottom').addClass('active');
      //   setTimeout(function () {
      //     $('.header-search__form form input[name="q"]').focus();
      //   }, 500);
      // });
      $('.site-header .search-form form .close-search').click(function () {
        $(this)
          .closest('.site-header')
          .find('.header-mb-left.header-mb-items, .header-bottom')
          .removeClass('active')
          .find('form input[name="q"]')
          .blur();
      });
      // $(document).on('click', '.snize-ac-results .snize-close-button', function () {
      //   $('.site-header .header-mb-left.header-mb-items, .header-bottom').removeClass('active');
      // });
    }

    if ($('.product-quick-add--variants.slick-initialized').length) {
      $('.product-quick-add--variants.slick-initialized').slick('refresh');
    }

    const htmlSelector = document.querySelector('html');
    Array.from(htmlSelector.classList).map(function (cls) {
      if (cls.indexOf('device--') > -1) htmlSelector.classList.remove(cls);
    });

    const browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    if (browserZoomLevel > 250) $('html').addClass('mode--zoom');
    else $('html').removeClass('mode--zoom');
    if (screen.availWidth > 767) {
      $('html').addClass('device--ipadandup');
    } else {
      $('html').addClass('device--mobile');
    }

    if (browserZoomLevel > 250 && screen.availWidth > 767) {
      window.LiveChatWidget && window.LiveChatWidget.call('hide');
    } else {
      window.LiveChatWidget && window.LiveChatWidget.call('minimize');
    }

    const oSClass = 'device--' + _theme.getOS();
    const deviceClass = 'device--' + _theme.getOS() + '-v-' + _theme.iPhoneVersion();
    htmlSelector.classList.add(oSClass);
    htmlSelector.classList.add(deviceClass);
  }

  initDeviceVaries();

  $('.klarna-faq-drop').each(function () {
    const hasLi = $(this).find('.klarna-faq-block .rte ul li').length > 0;
    if (!hasLi) {
      const sourceText = $(this).find('.klarna-faq-block .rte').html();
      const StrippedString1 = sourceText.replace(/(<([^>]+)>)/gi, '').toString();
      const StrippedString = StrippedString1.toString();
      if (sourceText) {
        if (StrippedString.length >= 150) {
          const lesstext = StrippedString.substr(0, 150);
          const lessFinal = `<span class='less-text-fn'>${lesstext}<span class='read-more-btn-col' role='button' tabindex='0'>...<u>view more</u></span></span>`;
          const moretext = StrippedString.substr(0, StrippedString.length);
          const moreFinal = `<span class='more-text-fn'>${sourceText}<span class='read-less-btn-col' role='button' tabindex='0'><u>view less</u></span></span>`;
          const finalText = lessFinal + moreFinal;
          $(this).find('.klarna-faq-block .rte').html(`<p class="vis-desk">${finalText}</p>`);
          $(this).find('.klarna-faq-block .rte').html(`<p class="vis-mob">${finalText}</p>`);
          const read_more = $(this).find('.read-more-btn-col');
          const read_less = $(this).find('.read-less-btn-col');
          read_more.click(function (e) {
            $(this).closest('p').addClass('show-more').find('.read-less-btn-col').focus();
          });
          read_less.click(function (e) {
            $(this).closest('p').removeClass('show-more').find('.read-more-btn-col').focus();
          });
          read_more.on('keyup', function (evt) {
            if (evt.key.toUpperCase() === 'ENTER') {
              evt.target.click();
            }
          });
          read_less.on('keyup', function (evt) {
            if (evt.key.toUpperCase() === 'ENTER') {
              evt.target.click();
            }
          });
        } else {
          $(this).find('.klarna-faq-block .rte').html(`<p>${StrippedString}</p>`);
        }
      }
    }
  });

  _theme.initSlickSlider($('.article-slider2'), {
    infinite: false,
    arrows: true,
    // prevArrow: "<button aria-label='Previous' class=\"slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
    // nextArrow: "<button aria-label='Next' class=\"slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });

  _theme.initSlickSlider(
    $('.chris-coll-wrap.carouselGrid'),
    {
      infinite: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow:
        "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
      nextArrow:
        "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
      ],
    },
    function (slick) {
      $(this).on('init beforeChange afterChange', function (event, slick, currentSlide, nextSlide) {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="true"] .smartwishlist').attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="false"]')
          .find('.smartwishlist')
          .attr('tabindex', 0);

        setTimeout(function () {
          slick.$slider.find('.slick-slide').removeAttr('tabindex');
          slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
          slick.$slider
            .find('.slick-slide[aria-hidden="true"] .smartwishlist')
            .attr('tabindex', -1);
          slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
          slick.$slider
            .find('.slick-slide[aria-hidden="false"]')
            .find('.smartwishlist')
            .attr('tabindex', 0);
        }, 2000);
      });
    }
  );

  _theme.initSlickSlider($('.chris-brands-wrap'), {
    infinite: false,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:
      "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
    nextArrow:
      "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1290,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  });

  $('#cross').click(function () {
    $('.sidebar-head').hide();
  });
  const $emptyCollSlider = $('.empty-cart-coll-slider');
  if ($emptyCollSlider.length) {
    _theme.initSlickSlider($emptyCollSlider, {
      infinite: false,
      arrows: true,
      dots: false,
      // prevArrow: '<button class="slick-prev slider-slick-prev" aria-label="Previous" type="button"><i class="arrow1 left1"></i><span class="sr-only">Previous</span></button>',
      // nextArrow: '<button class="slick-next slider-slick-next" aria-label="Next" type="button"><i class="arrow1 right1"></i><span class="sr-only">Next</span></button>',
      slidesToShow: 1.5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
  _theme.initSlickSlider(
    $('#dropdown-cart .products-grid.new-products-grid'),
    {
      dots: false,
      // prevArrow: "<button aria-label='Previous' class=\"slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
      // nextArrow: "<button aria-label='Next' class=\"slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    },
    function (slick) {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      setTimeout(function () {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      }, 1000);
    }
  );

  _theme.slickCallback = function (slick) {
    slick.$slider.find('.slick-slide').removeAttr('tabindex');
    slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
    slick.$slider.find('.slick-slide[aria-hidden="true"] .smartwishlist').attr('tabindex', -1);
    slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
    slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="false"]  .smartwishlist').attr('tabindex', 0);
      slick.$slider
        .find('.slick-slide[aria-hidden="true"] .bv_main_container')
        .attr('tabindex', -1);
      // slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
    }, 1000);
    setTimeout(function () {
      slick.$slider.find('.slick-slide').find('.smartwishlist').removeAttr('tabindex');
      slick.$slider
        .find('.slick-slide[aria-hidden="true"]')
        .find('.smartwishlist')
        .attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="false"]  .smartwishlist').attr('tabindex', 0);
      slick.$slider
        .find('.slick-slide[aria-hidden="true"] .bv_main_container')
        .attr('tabindex', -1);
    }, 2000);
  };

  /*-----------black-friday-start-----------------*/

  function checkSmartWishlistLoaded() {
    if ($('.smartwishlist .fa-heart-o').length > 0) {
      initializeSlickSlider();
    } else {
      setTimeout(checkSmartWishlistLoaded, 100);
    }
  }

  function initializeSlickSlider() {
    _theme.initSlickSlider(
      $('.slider-black-friday'),
      {
        infinite: false,
        arrows: true,
        dots: false,
        prevArrow:
          "<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
        nextArrow:
          "<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
        ],
      },
      function (slick) {
        $(this).on(
          'init afterChange beforeChange',
          function (event, slick, currentSlide, nextSlide) {
            _theme.slickCallback(slick);
          }
        );

        setTimeout(() => {
          $(this).on(
            'init afterChange beforeChange',
            function (event, slick, currentSlide, nextSlide) {
              _theme.slickCallback(slick);
            }
          );
        }, 1000);
      }
    );
    _theme.initSlickSlider(
      $('.featured-collection-section .featured-slider'),
      {
        infinite: false,
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        // prevArrow: "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
        // nextArrow: "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>",
        responsive: [
          {
            breakpoint: 1440,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 1040,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.6,
              slidesToScroll: 1,
              infinite: false,
            },
          },
          {
            breakpoint: 375,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              infinite: false,
            },
          },
        ],
      },
      function (slick) {
        $(this).on(
          'init afterChange beforeChange',
          function (event, slick, currentSlide, nextSlide) {
            _theme.slickCallback(slick);
          }
        );
        setTimeout(() => {
          $(this).on(
            'init afterChange beforeChange',
            function (event, slick, currentSlide, nextSlide) {
              _theme.slickCallback(slick);
            }
          );
        }, 1000);
      }
    );
  }
  checkSmartWishlistLoaded();

  let slickInitialized = false;
  function initializeSlick() {
    if (window.innerWidth > 480) {
      if (!slickInitialized) {
        _theme.initSlickSlider(
          $('.brand-item-slick'),
          {
            infinite: false,
            arrows: true,
            dots: false,
            prevArrow:
              "<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
            nextArrow:
              "<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
            slidesToShow: 6,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1199,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 992,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 640,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 480,
                settings: 'unslick',
              },
            ],
          },
          function (slick) {
            // Attach callback once on init
            $('.brand-item-slick').on(
              'init afterChange beforeChange',
              function (event, slick, currentSlide, nextSlide) {
                _theme.slickCallback(slick);
              }
            );
          }
        );
        slickInitialized = true;
      }
    } else {
      if (slickInitialized) {
        $('.brand-item-slick').slick('unslick');
        slickInitialized = false;
      }
    }
  }

  // Initialize Slick on page load
  $(document).ready(function () {
    initializeSlick();
  });

  // Reinitialize Slick on window resize
  $(window).resize(function () {
    initializeSlick();
  });

  /*-----------black-friday-blog-----------------*/
  _theme.initSlickSlider(
    $('.black-friday-blog'),
    {
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow:
        "<button type='button' tabindex='0' role='button' class='slick-arrow slick-prev'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Previous</span></button>",
      nextArrow:
        "<button type='button' tabindex='0' role='button' class='slick-arrow slick-next'><img src='//cdn.shopify.com/s/files/1/0269/7763/2389/files/new-slider-arrow.svg?v=163394481' alt=''><span class='sr-only'>Next</span></button>",
      slidesToShow: 5,
      slidesToScroll: 1,
      spaceBetween: 20,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            spaceBetween: 20,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },

        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    },
    function (slick) {
      $(this).on('init afterChange beforeChange', function (event, slick, currentSlide, nextSlide) {
        _theme.slickCallback(slick);
      });
      setTimeout(() => {
        $(this).on(
          'init afterChange beforeChange',
          function (event, slick, currentSlide, nextSlide) {
            _theme.slickCallback(slick);
          }
        );
      }, 2000);
    }
  );
  /*--------------black-friday-end---------------*/

  _theme.initSlickSlider(
    $('.spec-coll-prodGrid'),
    {
      infinite: false,
      arrows: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 1040,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.6,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
          },
        },
      ],
    },
    function (slick) {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="true"] .smartwishlist').attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      setTimeout(function () {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      }, 1000);
      setTimeout(function () {
        slick.$slider.find('.slick-slide').find('.smartwishlist').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"]')
          .find('.smartwishlist')
          .attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      }, 2000);
    }
  );

  _theme.initSlickSlider(
    $('.collectionBannerCarousel'),
    {
      infinite: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 1090,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 1020,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2.5,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
          },
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            infinite: false,
          },
        },
      ],
    },
    function (slick) {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="true"] .smartwishlist').attr('tabindex', -1);
      slick.$slider.find('.slick-slide[aria-hidden="false"]').removeAttr('tabindex');
      slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      setTimeout(function () {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider.find('.slick-slide[aria-hidden="true"]').attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      }, 1000);
      setTimeout(function () {
        slick.$slider.find('.slick-slide').find('.smartwishlist').removeAttr('tabindex');
        slick.$slider
          .find('.slick-slide[aria-hidden="true"]')
          .find('.smartwishlist')
          .attr('tabindex', -1);
        slick.$slider.find('.slick-slide[aria-hidden="false"] .smartwishlist').attr('tabindex', 0);
      }, 2000);
    }
  );

  _theme.initSlickBtnEvent = function () {
    const slickBtns = document.querySelectorAll('.slick-initialized .slick-arrow');
    slickBtns.forEach((btn) => {
      btn.removeEventListener('focusin', run);
      btn.addEventListener('focusin', run);
    });

    function run(evt) {
      const target = evt.target;
      target.classList.add('show-tooltip');
      setTimeout(() => {
        target.classList.remove('show-tooltip');
      }, 2500);
    }
  };
  _theme.initSlickBtnEvent();

  $('#accordion-tog').click(function () {
    $('#accordion-tog').toggleClass('active');
    $('.toggle-slide').stop().slideToggle();
  });

  $('.announcement-bar.gradient .container button.announcement-close-btn').click(function () {
    $('.announcement-bar.gradient').css('display', 'none');
    $('.announcement-bar.gradient').addClass('bar-removed');
    if ($('.announcement-bar.gradient').hasClass('bar-removed')) {
      $('header-search [data-ajax-search-results]').addClass('topUp');
      $('body').addClass('banner-removed');
    }
  });

  $('.reward-faq .panel-heading').on('click', function (e) {
    e.preventDefault();
    $(this).next(' .panel-collapse').toggleClass('show');
    const defPanelHead = $(this)
      .closest('.panel-heading')
      .find('.panel-title')
      .find('.default-expanded')
      .attr('aria-expanded');
    const panelStatus = $(this)
      .closest('.panel-heading')
      .find('.panel-title')
      .find('.collapsed')
      .attr('aria-expanded');
    if (defPanelHead === 'true') {
      $(this)
        .closest('.panel-heading')
        .find('.panel-title')
        .find('.default-expanded')
        .attr('aria-expanded', 'false');
    } else {
      $(this)
        .closest('.panel-heading')
        .find('.panel-title')
        .find('.default-expanded')
        .attr('aria-expanded', 'true');
    }
    if (panelStatus === 'false') {
      $(this)
        .closest('.panel-heading')
        .find('.panel-title')
        .find('.collapsed')
        .attr('aria-expanded', 'true');
    } else {
      $(this)
        .closest('.panel-heading')
        .find('.panel-title')
        .find('.collapsed')
        .attr('aria-expanded', 'false');
    }
  });

  $('.reward-faq .panel').each(function () {
    const sourceText = $(this).find('.panel-body .rte').html();
    const StrippedString1 = sourceText.replace(/(<([^>]+)>)/gi, '').toString();
    const StrippedString = StrippedString1.toString();
    if (sourceText) {
      if (StrippedString.length >= 150) {
        const lesstext = StrippedString.substr(0, 150);
        const lessFinal = `<span class='less-text-fn'>${lesstext}<span class='read-more-btn-col' role='button' tabindex='0'>... <u>view more</u></span></span>`;
        const moreFinal = `<span class='more-text-fn'>${sourceText}<span class='read-less-btn-col' role='button' tabindex='0'><u>view less</u></span></span>`;
        const finalText = lessFinal + moreFinal;
        $(this).find('.panel-body .rte').html(`<p class="vis-desk">${finalText}</p>`);
        $(this).find('.panel-body .rte').html(`<p class="vis-mob">${finalText}</p>`);
        const read_more = $(this).find('.read-more-btn-col');
        const read_less = $(this).find('.read-less-btn-col');
        read_more.click(function (e) {
          $(this).closest('p').addClass('show-more').find('.read-less-btn-col').focus();
        });
        read_less.click(function (e) {
          $(this).closest('p').removeClass('show-more').find('.read-more-btn-col').focus();
        });

        read_more.on('keyup', function (evt) {
          if (evt.key.toUpperCase() === 'ENTER') {
            evt.target.click();
          }
        });
        read_less.on('keyup', function (evt) {
          if (evt.key.toUpperCase() === 'ENTER') {
            evt.target.click();
          }
        });
      } else {
        $(this).find('.panel-body .rte').html(`<p>${StrippedString}</p>`);
      }
    }
  });

  // if(_theme.isMobile){
  //   $('.desktop-navigation-wrap').remove();
  // }

  if (_theme.isLaptopAndUp) {
    // $('header[role="banner"]').remove();
    $('.mobile-newsletter-view').remove();
  } else {
    $('.desktop-newsletter-view').remove();
  }

  if (_theme.isMobile) {
    // $('.section-advantage.pink__container').removeAttr('role')
  } else {
    $('.header-default.main-header').removeAttr('role');
  }

  $(document).on('keyup', '.smartwishlist', function (e) {
    if (e.which === 13) {
      $(this).trigger('click');
    }
  });

  $(document).on('keyup', '.sidebar-mob .sidebar-filter .widget .sidebar-title', function (e) {
    if (e.which === 13) {
      $(this).trigger('click');
    }
  });

  if (_theme.isMobile) {
    $('.account-show-desktop-only').remove();
  } else {
    $('.account-show-mobile-only').remove();
  }

  if ($('.cm-footer-content').length) {
    $('.cm-footer-content a').removeAttr('title');
    $('.cm-footer-content a').attr('aria-label', 'Read more about fragrancemarket.com');
  }

  $('.Account-links ul li').on('click', function () {
    setTimeout(function () {
      $('.Account-links ul li a').each(function () {
        if (window.location.href.includes($(this).attr('href'))) {
          $(this).attr('aria-current', 'true');
        } else {
          $(this).attr('aria-current', 'false');
        }
      });
    }, 500);
  });
  $('.Account-links ul li').trigger('click');

  $('#search_filter-1').on('keypress', function () {});

  $('.btn-padd42').on('click', function () {
    $(this).attr('aria-expanded') == 'false'
      ? $(this).attr('aria-expanded', 'true')
      : $(this).attr('aria-expanded', 'false');
  });
  $('.action-btn a').on('click', function () {
    $('.btn-padd42').attr('aria-expanded', 'false');
  });

  if (window.location.href.includes('tracktor')) {
    document.title = 'Track Your Order | Fragrance Market';
  }

  $('.tagDiv ul li a').each(function () {
    const href = window.location.href;
    if (href.includes($(this).attr('href'))) {
      $(this).attr('aria-current', 'true');
    }
  });

  window.onresize = debounce(initDeviceVaries, 300);
});

function clickWishlistBtn() {
  const wishlistItems = document.querySelectorAll('.smartwishlist');

  wishlistItems.forEach(function (item) {
    item.addEventListener('click', function () {
      const wishlistContainer = item.closest('.wishlist-container');
      if (wishlistContainer) {
        const ariaLiveElement = wishlistContainer.querySelector('[data-aria-live]');
        if (ariaLiveElement) {
          if (item.classList.contains('bookmarked')) {
            ariaLiveElement.innerHTML = 'Added to wishlist';
            setTimeout(function () {
              ariaLiveElement.innerHTML = '';
            }, 1000);
          } else {
            ariaLiveElement.innerHTML = 'Removed from wishlist';
            setTimeout(function () {
              ariaLiveElement.innerHTML = '';
            }, 1000);
          }
        }
      }
    });
  });
}

function SWCallbackCustomerWishlistCollectionItemAdded() {
  handleWishlistChange();
  handleWishlistPageChanges();
}
function SWCallbackCustomerWishlistCollectionItemRemoved() {
  handleWishlistChange();
  handleWishlistPageChanges();
}
function SWCallbackExpressWishlistCollectionItemAdded() {
  handleWishlistChange();
  handleWishlistPageChanges();
}
function SWCallbackExpressWishlistCollectionItemRemoved() {
  handleWishlistChange();
  handleWishlistPageChanges();
}
function handleWishlistChange() {
  // let t=document.querySelectorAll(".smartwishlist");t.forEach(function(t,e){let i=t.dataset.title;t.removeAttribute('title');if(!i)return;let l="Add to Wishlist "+i;t.classList.contains("bookmarked")&&(l="Remove from Wishlist "+i),t.setAttribute("aria-label",l)})
  const t = document.querySelectorAll('.smartwishlist');
  t.forEach(function (t, e) {
    const i = t.dataset.title;
    t.removeAttribute('title');
    if (!i) return;
    let l = 'Add to Wishlist ' + i;
    t.classList.contains('bookmarked') && (l = 'Remove from Wishlist ' + i),
      t.setAttribute('aria-label', l);
  });
  setTimeout(() => {
    try {
      const wishCountElem = document.querySelectorAll('.topbadge');
      if (wishCountElem.length === 0) return;
      wishCountElem.forEach((elem) => {
        const count = parseInt(elem.textContent);
        const parent = elem.closest('a');
        if (!parent) return;
        parent.setAttribute(
          'aria-label',
          'Wishlist with ' + count + ' ' + (count > 1 ? 'items' : 'item')
        );
        const srText = parent.querySelector('.wishlist-topbadge-sr-only');
        if (srText) srText.textContent = count > 1 ? 'items' : ' 0 item';
      });
    } catch (err) {}
  }, 300);
  clickWishlistBtn();
}
function handleWishlistPageChanges() {
  if ($('.section-wishlist').length === 0) return;
  if (window.SWGetExpressWishlistId) _theme.buildhWishlistGrid('.section-wishlist .wishlist-items');
}

window.addEventListener('DOMContentLoaded', function () {
  setTimeout(handleWishlistChange, 2000);
  setTimeout(handleWishlistChange, 4000);
});

window.onload = function () {
  setTimeout(handleWishlistChange, 2000);
  setTimeout(handleWishlistChange, 5000);
};
_theme.initSlickSlider(
  $('.article-recommend-slider'),
  {
    dots: false,
    arrows: true,
    // prevArrow: "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
    // nextArrow: "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>",
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],
  },
  function (slick) {
    slick.$slider.find('.slick-slide').removeAttr('tabindex');
    slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
    }, 1000);
  }
);
if (_theme.isIpad) {
  _theme.initSlickSlider(
    $('.products-wrapper'),
    {
      dots: false,
      arrows: true,
      // prevArrow: "<button aria-label='Previous' type='button' class='slick-arrow slick-prev'><i class='arrow1 left1'></button>",
      // nextArrow: "<button aria-label='Next' type='button' class='slick-arrow slick-next'><i class='arrow1 right1'></button>",
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          },
        },
      ],
    },
    function (slick) {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
      slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      setTimeout(function () {
        slick.$slider.find('.slick-slide').removeAttr('tabindex');
        slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
      }, 1000);
    }
  );
}
const isTabMobile = window.innerWidth <= 1024; // You can adjust this breakpoint
if (isTabMobile) {
  _theme.initSlickSlider($('.announcement-slider'), {
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  });
  $('.announcement-slider').init(function () {
    $('.announcement-slider').removeClass('opacity-none');
    $('.skelton-item').hide();
  });
  $('.bar-play-pause').on('click', function () {
    $(this).toggleClass('active');
    const slider = $('.announcement-slider');
    if ($(this).hasClass('active')) {
      slider.slick('slickPause');
    } else {
      slider.slick('slickPlay');
    }
  });
}

_theme.initSlickSlider(
  $('.article-product-grid'),
  {
    infinite: false,
    arrows: true,
    dots: false,
    // prevArrow: "<button aria-label='Previous' class=\"slick-prev slider-slick-prev\"><i class='arrow1 left1'></button>",
    // nextArrow: "<button aria-label='Next' class=\"slick-next slider-slick-next\"><i class='arrow1 right1'></button>",
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
          arrows: true,
        },
      },
    ],
  },
  function (slick) {
    slick.$slider.find('.slick-slide').removeAttr('tabindex');
    slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
    setTimeout(function () {
      $('.slick-slide').each(function () {
        if ($(this).hasClass('slick-active')) {
          $(this).find('.smartwishlist').attr('tabindex', '0');
        } else {
          $(this).find('.smartwishlist').attr('tabindex', '-1');
        }
      });
    }, 10000);
  },
  function (slick) {
    slick.$slider.find('.slick-slide').removeAttr('tabindex');
    slick.$slider.find('.slick-slide').removeAttr('aria-hidden');
    setTimeout(function () {
      slick.$slider.find('.slick-slide').removeAttr('tabindex');
    }, 1000);
    $('.slick-slide').each(function () {
      if ($(this).hasClass('slick-active')) {
        $(this).find('.smartwishlist').attr('tabindex', '0');
      } else {
        $(this).find('.smartwishlist').attr('tabindex', '-1');
      }
    });
  }
);
$(document).ready(function () {
  var sliderFocusAda = setInterval(function () {
    const btnFound = $('.grid-item[aria-hidden="true"] [data-bv-show="inline_rating"] a').length;
    const wishListLoaded = $('.grid-item[aria-hidden="true"] .smartwishlist').length;
    if (btnFound && wishListLoaded) {
      clearInterval(sliderFocusAda);
      tweakBVLayout();
    }
  }, 2000);
  setTimeout(function () {
    clearInterval(sliderFocusAda);
  }, 10000);
});

const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');

addToCartButtons.forEach((button) => {
  button.addEventListener('click', function () {
    const variantId = this.getAttribute('data-variant-id');
    const innerButton = this.classList.contains('fbt-add-to-cart');
    _theme.toggleLoading(1);

    // Do Not Remove Code - Add Properties for GWP Discount
    const properties = {};
    const bundleVarIdElement = this.closest('.grid-item').querySelector('[data-bundleVarId]');
    if (bundleVarIdElement) {
      properties['_bundleVarId'] = bundleVarIdElement.value || null;
    }
    // Do Not Remove Code - Add Properties for GWP Discount

    _theme.Helpers.addProductToCart(
      variantId,
      1,
      properties,
      (resp) => {
        _theme.MiniCart.lineItemChangeCallBack(resp, function () {
          _theme.toggleLoading();
          _theme.toggleSideCart(1, null, true);
          innerButton &&
            document
              .querySelector('#dropdown-cart .has-items-wrapper.custom-slider-scrollbar')
              .scrollTo({
                top: 0,
                behavior: 'smooth',
              });
        });
      },
      (err) => {
        console.error(err);
      },
      1
    );
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const variantSelectors = document.querySelectorAll('.variant-select');

  variantSelectors.forEach((select) => {
    select.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const prodIndex = this.getAttribute('data-prod-index');
      const priceContainer = document.getElementById(`product-price-${prodIndex}`);
      const addToCartButton = document.querySelector(
        `.add-to-cart-btn[data-prod-index='${prodIndex}']`
      );

      const currentPrice = selectedOption.getAttribute('data-price');
      const compareAtPrice = selectedOption.getAttribute('data-compare-at-price');

      priceContainer.querySelector('.current-price').innerText =
        `$${(currentPrice / 100).toFixed(2)}`;

      if (compareAtPrice) {
        priceContainer.querySelector('.compare-at-price').innerText =
          `$${(compareAtPrice / 100).toFixed(2)}`;
        const discountAmount = compareAtPrice - currentPrice;
        priceContainer.querySelector('.disc-amount').innerText =
          `Save $${(discountAmount / 100).toFixed(2)}`;
      } else {
        priceContainer.querySelector('.compare-at-price').innerText = '';
        priceContainer.querySelector('.disc-amount').innerText = '';
      }
      addToCartButton.setAttribute('data-variant-id', selectedOption.value);
    });
  });
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('empty-cart-atc-btn')) {
      const firstVarId = event.target.getAttribute('data-f-var-id');
      console.log(firstVarId);
      if (!firstVarId) return;
      _theme.toggleLoading(1);
      _theme.Helpers.addItem(
        firstVarId,
        1,
        function () {
          _theme.toggleLoading();
          _theme.toggleSideCart(1, null, true);
        },
        1
      );
    }
  });
  const targetNode = document.body;

  const observer = new MutationObserver((mutationsList, observer) => {
    const element = document.getElementById('merchantwidget-iframe-wrapper');
    if (element) {
      element.style.zIndex = '10';
      observer.disconnect();
    }
  });

  const config = { childList: true, subtree: true };

  observer.observe(targetNode, config);
  document
    .querySelector('#google-merchantwidget-iframe-wrapper iframe')
    ?.setAttribute('title', 'Google Store Badge');

  document.querySelectorAll('[data-gif-logo]').forEach((gifLogo) => {
    const gifSrc = gifLogo.dataset.gifLogo;
    const gifSrcAlt = gifLogo.dataset.afterPauseAlt;

    if (gifSrc) {
      setTimeout(() => {
        gifLogo.src = '';
        gifLogo.src = gifSrc;

        if (gifSrcAlt) {
          gifLogo.alt = gifSrcAlt;
        }
      }, 5000);
    }
  });
});

// Function to remove the 'title="Add to <a href='/a/wishlist'>Wishlist</a>"' from elements with the 'smartwishlist' class
function removeTitleAttribute(mutationsList) {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'title') {
      const target = mutation.target;
      if (target.classList.contains('smartwishlist') && target.closest('.wishlist-container')) {
        target.removeAttribute('title');
      }
    }
  });
}
const observer = new MutationObserver(removeTitleAttribute);
observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['title'] });
// End code
